(() => {
  const SELECTOR = '[data-lbx-catalog]';
  const STORAGE_KEY = 'labosch_catalog_view_mode';
  const CLIENT_ONLY_FILTERS = true;
  const PRESERVE_PARAMS = ['view', 'preview_theme_id', '_ab', '_fd', '_sc'];

  const getCatalogLabel = (root, name, fallback) => {
    const source = root || document.querySelector(SELECTOR);
    return source?.getAttribute?.(`data-lbx-label-${name}`) || fallback;
  };


  const enforceManualSortByDefault = () => {
    const url = new URL(window.location.href);
    const sortBy = String(url.searchParams.get('sort_by') || '').trim();
    if (sortBy === 'most-relevant' || sortBy === 'relevance') {
      url.searchParams.set('sort_by', 'manual');
      window.location.replace(url.toString());
      return true;
    }
    return false;
  };

  if (enforceManualSortByDefault()) return;

  const normalizeText = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();


  const normalizeImageUrl = (url = '') => {
    try {
      const parsed = new URL(url, window.location.origin);
      parsed.searchParams.delete('width');
      parsed.searchParams.delete('height');
      return `${parsed.origin}${parsed.pathname}`;
    } catch (error) {
      return String(url).split('?')[0];
    }
  };

  const lbxPreloadedImages = new Set();

  const preloadImage = (src) => {
    if (!src || lbxPreloadedImages.has(src)) return;
    lbxPreloadedImages.add(src);
    const image = new Image();
    image.decoding = 'async';
    image.loading = 'eager';
    image.src = src;
  };

  const initHoverImages = (root) => {
    root.querySelectorAll('[data-lbx-product-media]').forEach((media) => {
      if (media.dataset.lbxHoverReady === 'true') return;
      media.dataset.lbxHoverReady = 'true';

      const img = media.querySelector('[data-lbx-primary-src]');
      if (!img) return;

      const initialHover = img.getAttribute('data-lbx-hover-src');
      if (initialHover) preloadImage(initialHover);

      media.addEventListener('pointerenter', (event) => {
        if (event.target.closest?.('[data-lbx-color-swatches]')) return;

        const primary = img.getAttribute('data-lbx-primary-src') || img.currentSrc || img.src;
        const hover = img.getAttribute('data-lbx-hover-src');

        if (!hover || !primary || normalizeImageUrl(hover) === normalizeImageUrl(primary)) return;

        img.src = hover;
      });

      media.addEventListener('pointerleave', () => {
        const card = media.closest('[data-lbx-product-card]');
        if (img.getAttribute('data-lbx-temp-swatch-active') === 'true' && card) {
          persistTemporarySwatchImage(card);
          return;
        }

        const primary = img.getAttribute('data-lbx-primary-src') || img.currentSrc || img.src;
        if (primary) img.src = primary;
      });
    });
  };

  const getCheckedLabels = (root) => {
    const map = {};
    root.querySelectorAll('[data-lbx-filter-form] input[type="checkbox"]:checked').forEach((input) => {
      const key = input.name || '';
      const label = normalizeText(input.closest('label')?.querySelector('i')?.textContent || input.value || '');
      if (!key || !label) return;
      if (!map[key]) map[key] = [];
      map[key].push(label);
    });
    return map;
  };

  const filterKeyType = (key, label) => {
    const text = normalizeText(`${key} ${label}`);
    if ((text.includes('recorrido') && (text.includes('suspension') || text.includes('suspensión'))) || text.includes('recorrido_suspension') || text.includes('recorrido-suspension')) return 'travel';
    if (text.includes('filter.v.option') || text.includes('option.')) return 'options';
    if (text.includes('badge_categoria') || text.includes('categoria') || text.includes('categor')) return 'category';
    if (text.includes('modalidad') || text.includes('disciplina') || text.includes('uso principal')) return 'discipline';
    if (text.includes('vendor') || text.includes('marca')) return 'brand';
    if (text.includes('availability') || text.includes('disponibilidad')) return 'availability';
    return '';
  };

  const applyInstantFilterPreview = (root) => {
    const checked = getCheckedClientFilterItems(root);
    const materialActive = getClientMaterialModes();
    let visible = 0;

    root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
      let show = true;

      if (materialActive.size && !materialActive.has(normalizeText(card.getAttribute('data-lbx-material')))) {
        show = false;
      }

      if (show && !cardMatchesFilterItems(card, checked)) show = false;

      setCardVisible(card, show);
      if (show) visible += 1;
    });

    const visibleCount = root.querySelector('[data-lbx-visible-count]');
    if (visibleCount) visibleCount.textContent = String(visible);
    sortVisibleCards(root);
    syncQuickChips(root);
    updateProductImagesForSelectedColor(root);
  };



  const tokenText = (value) => normalizeText(value)
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const valueAliases = (value, type = '') => {
    const text = tokenText(value);
    const aliases = new Set([text]);

    const addColorFamily = (family) => {
      const families = {
        black: ['black', 'negro', 'negra'],
        white: ['white', 'blanco', 'blanca'],
        grey: ['grey', 'gray', 'gris', 'plata', 'silver', 'titanium', 'titanio'],
        blue: ['blue', 'azul', 'navy', 'marine', 'marino'],
        green: ['green', 'verde', 'argile', 'olive', 'oliva'],
        red: ['red', 'rojo', 'roja'],
        orange: ['orange', 'naranja'],
        yellow: ['yellow', 'amarillo', 'amarilla'],
        brown: ['brown', 'marron', 'marrón', 'cafe', 'café'],
        beige: ['beige', 'cream', 'crema', 'sand', 'arena'],
        purple: ['purple', 'purpura', 'púrpura', 'morado', 'morada', 'violeta', 'lila', 'lavender', 'lilac', 'amethyst'],
        pink: ['pink', 'rosa'],
        gold: ['gold', 'dorado', 'dorada'],
        copper: ['copper', 'cobre']
      };
      (families[family] || []).forEach((alias) => aliases.add(tokenText(alias)));
    };

    if (type === 'color') {
      const colorFamilies = {
        black: ['black', 'negro', 'negra'],
        white: ['white', 'blanco', 'blanca'],
        grey: ['grey', 'gray', 'gris', 'plata', 'silver', 'titanium', 'titanio'],
        blue: ['blue', 'azul', 'navy', 'marine', 'marino'],
        green: ['green', 'verde', 'argile', 'olive', 'oliva'],
        red: ['red', 'rojo', 'roja'],
        orange: ['orange', 'naranja'],
        yellow: ['yellow', 'amarillo', 'amarilla'],
        brown: ['brown', 'marron', 'marrón', 'cafe', 'café'],
        beige: ['beige', 'cream', 'crema', 'sand', 'arena'],
        purple: ['purple', 'purpura', 'púrpura', 'morado', 'morada', 'violeta', 'lila', 'lavender', 'lilac', 'amethyst'],
        pink: ['pink', 'rosa'],
        gold: ['gold', 'dorado', 'dorada'],
        copper: ['copper', 'cobre']
      };

      Object.entries(colorFamilies).forEach(([family, words]) => {
        if (words.some((word) => text.includes(tokenText(word)))) addColorFamily(family);
      });
    }

    if (text.includes('trekking') || text.includes('hibrida') || text.includes('hibrido') || text.includes('hybrid')) {
      aliases.add('trekking');
      aliases.add('hibrida');
      aliases.add('hibrido');
    }
    if (text.includes('montana') || text.includes('montaña') || text.includes('mountain') || text.includes('mtb')) aliases.add('montana');
    if (text.includes('urbana') || text.includes('urbano') || text.includes('urban') || text.includes('city') || text.includes('ciudad')) aliases.add('urbana');
    if (text.includes('gravel') || text.includes('all road')) aliases.add('gravel');
    if (text.includes('carga') || text.includes('cargo')) aliases.add('carga');
    if (text.includes('bosch')) aliases.add('bosch');
    if (text.includes('dji')) aliases.add('dji');
    if (text.includes('shimano')) aliases.add('shimano');
    if (text.includes('yamaha')) aliases.add('yamaha');
    if (text.includes('brose')) aliases.add('brose');
    return Array.from(aliases).filter(Boolean);
  };

  const numericParts = (value) => (String(value || '').match(/\d+/g) || []);


  const availabilityFilterIntent = (item = {}) => {
    const raw = tokenText(`${item.label || ''} ${item.value || ''}`);

    if (
      raw.includes('sin stock') ||
      raw.includes('agotado') ||
      raw.includes('sold out') ||
      raw.includes('out of stock') ||
      raw.includes('unavailable') ||
      raw === 'false' ||
      raw === '0'
    ) return 'sold-out';

    // El filtro visible de LaBosch se llama "Envío en 24/48h".
    // Debe significar stock propio inmediato, no stock proveedor.
    if (
      raw.includes('envio') ||
      raw.includes('24 48') ||
      raw.includes('24h') ||
      raw.includes('48h') ||
      raw.includes('24 48h')
    ) return 'own-stock';

    if (
      raw.includes('en stock') ||
      raw.includes('in stock') ||
      raw.includes('available') ||
      raw.includes('disponible') ||
      raw === 'true' ||
      raw === '1'
    ) return 'available';

    return '';
  };

  const availabilityMatches = (cardValueRaw, item = {}) => {
    const status = tokenText(cardValueRaw);
    const intent = availabilityFilterIntent(item);

    if (intent === 'own-stock') {
      return status === 'in stock' || status === 'in-stock';
    }

    if (intent === 'available') {
      return status === 'in stock' || status === 'in-stock' || status === 'supplier stock' || status === 'supplier-stock';
    }

    if (intent === 'sold-out') {
      return status === 'sold out' || status === 'sold-out';
    }

    return false;
  };

  const clientValueMatches = (cardValueRaw, item, type = '') => {
    const cardValue = tokenText(cardValueRaw);
    const labelAliases = valueAliases(item.label || item.value || '', type);
    const valueAliasesList = valueAliases(item.value || item.label || '', type);
    const needles = [...new Set([...labelAliases, ...valueAliasesList])].filter(Boolean);

    if (!cardValue && needles.length) return false;

    if (type === 'availability') {
      return availabilityMatches(cardValueRaw, item);
    }

    if (type === 'battery' || type === 'motor' || type === 'travel') {
      const needleNums = numericParts(`${item.label} ${item.value}`);
      const cardNums = numericParts(cardValueRaw);

      if (type === 'battery' && needleNums.length) {
        return needleNums.some((num) => cardNums.includes(num));
      }

      if (type === 'travel') {
        const raw = tokenText(`${item.label} ${item.value}`);
        const exactCard = tokenText(cardValueRaw);

        const travelBucket = (text) => {
          const value = tokenText(text);
          const nums = numericParts(value).map(Number);

          if (!value) return '';
          if (value.includes('sin') && value.includes('suspension')) return 'sin-suspension';
          if (value.includes('hasta') && nums.includes(120)) return 'hasta-120';
          if (nums.includes(120) && nums.includes(140)) return '120-140';
          if (nums.includes(140) && nums.includes(160)) return '140-160';
          if ((value.includes('mas') || value.includes('mayor') || value.includes('superior') || value.includes('+')) && nums.includes(160)) return 'mas-160';
          return '';
        };

        const filterBucket = travelBucket(raw);
        const cardBucket = travelBucket(exactCard);

        // Primary logic: exact bucket from the actual metafield validation list.
        // Valid values: Sin Suspensión, Hasta 120 mm, 120 - 140 mm, 140 - 160 mm, Más de 160 mm.
        if (filterBucket || cardBucket) {
          return Boolean(filterBucket && cardBucket && filterBucket === cardBucket);
        }

        // Strict exact fallback for non-standard but textual values.
        if (exactCard && raw) {
          if (exactCard === raw) return true;
        }

        // Numeric fallback only for future/manual values that are not one of the validation buckets.
        if (!needleNums.length || !cardNums.length) return false;

        const minCard = Math.min(...cardNums.map(Number));
        const maxCard = Math.max(...cardNums.map(Number));

        if (raw.includes('hasta') || raw.includes('menos') || raw.includes('menor')) {
          const limit = Math.max(...needleNums.map(Number));
          return maxCard <= limit;
        }

        if (raw.includes('mas') || raw.includes('mayor') || raw.includes('superior') || raw.includes('+')) {
          const limit = Math.max(...needleNums.map(Number));
          return maxCard > limit;
        }

        if (needleNums.length >= 2) {
          const minNeedle = Math.min(...needleNums.map(Number));
          const maxNeedle = Math.max(...needleNums.map(Number));
          return minCard >= minNeedle && maxCard <= maxNeedle;
        }

        return needleNums.some((num) => cardNums.includes(num));
      }
    }

    if (type === 'color') {
      return needles.some((needle) => {
        if (!needle) return false;
        return cardValue === needle ||
          cardValue.split(/\s+/).includes(needle) ||
          cardValue.includes(` ${needle} `) ||
          cardValue.startsWith(`${needle} `) ||
          cardValue.endsWith(` ${needle}`) ||
          cardValue.includes(needle);
      });
    }

    return needles.some((needle) => {
      if (!needle) return false;
      return cardValue === needle || cardValue.includes(` ${needle} `) || cardValue.startsWith(`${needle} `) || cardValue.endsWith(` ${needle}`) || cardValue.includes(needle);
    });
  };


  const cleanFormValue = (value) => {
    let clean = String(value || '').trim();
    clean = clean.replace(/€/g, '').replace(/\s+/g, '').replace(/\./g, '').replace(/,/g, '.');
    return clean;
  };

  const getParams = () => new URLSearchParams(window.location.search);
  const getRoot = () => document.querySelector(SELECTOR);
  const getOfferMode = () => {
    const root = getRoot();
    if (root && root.dataset.lbxOfferMode) return root.dataset.lbxOfferMode === '1';
    return getParams().get('lbx_offer') === '1' || getParams().get('lb_sale') === '1';
  };
  const getClientMaterialModes = () => {
    const root = getRoot();
    const source = root?.dataset.lbxMaterialMode || getParams().get('lbx_material') || '';
    return new Set(String(source).split(',').map(normalizeText).filter(Boolean));
  };
  const setOfferMode = (root, active) => {
    if (root) root.dataset.lbxOfferMode = active ? '1' : '0';
  };
  const setClientMaterialModes = (root, activeSet) => {
    if (root) root.dataset.lbxMaterialMode = Array.from(activeSet).join(',');
  };


  const normalizeUrlCategory = (value) => {
    const text = tokenText(value || '');
    if (!text) return '';
    if (text.includes('montana') || text.includes('mountain') || text.includes('mtb')) return 'montana';
    if (text.includes('trekking') || text.includes('hibrida') || text.includes('hibrido') || text.includes('hybrid')) return 'trekking';
    if (text.includes('urbana') || text.includes('urban') || text.includes('ciudad')) return 'urbana';
    if (text.includes('gravel')) return 'gravel';
    if (text.includes('carga') || text.includes('cargo')) return 'carga';
    if (text.includes('nino') || text.includes('infantil') || text.includes('kids') || text.includes('kid')) return 'ninos';
    return text;
  };

  const getClientCategoryFromUrl = () => {
    const params = getParams();
    return normalizeUrlCategory(params.get('lbx_cat') || params.get('lbx_category') || params.get('lbx_use') || '');
  };

  const getLegacyShopifyCategoryFromUrl = () => {
    const params = getParams();
    let value = '';
    params.forEach((paramValue, paramKey) => {
      const key = String(paramKey || '').toLowerCase();
      if (value) return;
      if (key === 'filter.p.m.labosch.badge_categoria' || key.includes('badge_categoria')) value = paramValue;
    });
    return normalizeUrlCategory(value);
  };

  const redirectLegacyShopifyCategoryToClientUrl = () => {
    const params = getParams();
    if (params.has('lbx_cat') || params.has('lbx_category')) return false;

    const legacyCategory = getLegacyShopifyCategoryFromUrl();
    if (!legacyCategory) return false;

    const nextUrl = new URL(window.location.href);
    const keysToDelete = [];
    nextUrl.searchParams.forEach((value, key) => {
      const normalizedKey = String(key || '').toLowerCase();
      if (normalizedKey === 'filter.p.m.labosch.badge_categoria' || normalizedKey.includes('badge_categoria')) keysToDelete.push(key);
    });
    keysToDelete.forEach((key) => nextUrl.searchParams.delete(key));

    nextUrl.searchParams.set('lbx_cat', legacyCategory);
    if (!nextUrl.searchParams.has('sort_by')) nextUrl.searchParams.set('sort_by', 'manual');
    if (!nextUrl.searchParams.has('pb')) nextUrl.searchParams.set('pb', '0');

    window.location.replace(nextUrl.toString());
    return true;
  };

  const applyUrlCategoryFilter = (root) => {
    const category = getClientCategoryFromUrl();
    if (!category) return false;

    let matched = false;
    findCategoryInputs(root).forEach((input) => {
      const item = getClientFilterItem(input);
      const shouldCheck = clientValueMatches(category, item, 'category');
      input.checked = shouldCheck;
      input.closest('.lbxcat-check, .lbxcat-color')?.classList.toggle('is-active', shouldCheck);
      if (shouldCheck) matched = true;
    });

    return matched;
  };


  const advisorUrlList = (key) => String(getParams().get(key) || '')
    .split(',')
    .map((item) => tokenText(item))
    .filter(Boolean);

  const advisorDisciplineTargetsFromUrl = () => {
    const params = getParams();
    const targets = new Set();
    advisorUrlList('lbx_discipline').forEach((item) => targets.add(item));
    const category = normalizeUrlCategory(params.get('lbx_cat') || '');
    const use = tokenText(params.get('lbx_use') || '');
    const terrain = tokenText(params.get('lbx_terrain') || '');

    if (category === 'montana') targets.add('montana');
    if (category === 'trekking') targets.add('trekking');
    if (category === 'urbana') targets.add('urbana');
    if (category === 'gravel') targets.add('gravel');
    if (category === 'carga') targets.add('carga');

    if (use.includes('trail') || terrain.includes('senderos')) targets.add('trail');
    if (use.includes('enduro') || terrain.includes('tecnico')) targets.add('enduro');
    if (use.includes('rutas') || use.includes('comodidad') || terrain.includes('mixto')) targets.add('trekking');
    if (use.includes('trabajo') || use.includes('paseos') || terrain.includes('ciudad')) targets.add('urbana');
    if (use.includes('pistas') || use.includes('carretera') || terrain.includes('aventura')) targets.add('gravel');
    if (use.includes('familia') || use.includes('recados') || use.includes('profesional') || terrain.includes('carga')) targets.add('carga');

    return Array.from(targets).filter(Boolean);
  };

  const advisorBudgetRangeFromUrl = () => {
    const params = getParams();
    const raw = tokenText(params.get('lbx_budget') || '');
    const explicitMin = cleanFormValue(params.get('lbx_price_min') || '');
    const explicitMax = cleanFormValue(params.get('lbx_price_max') || '');
    if (explicitMin || explicitMax) return { min: explicitMin, max: explicitMax };
    if (raw === 'hasta-2000') return { min: '', max: '2000' };
    if (raw === '2000-3000') return { min: '2000', max: '3000' };
    if (raw === '3000-4500') return { min: '3000', max: '4500' };
    if (raw === '4500-plus') return { min: '4500', max: '' };
    return { min: '', max: '' };
  };

  const applyAdvisorUrlFilters = (root) => {
    const params = getParams();
    if (!params.has('lbx_cat') && !params.has('lbx_size') && !params.has('lbx_budget') && !params.has('lbx_discipline') && !params.has('lbx_use') && !params.has('lbx_terrain') && !params.has('lbx_priority')) return false;

    let matched = false;
    const category = getClientCategoryFromUrl();
    const sizes = advisorUrlList('lbx_size');
    const disciplines = advisorDisciplineTargetsFromUrl();
    const budget = advisorBudgetRangeFromUrl();
    const priority = tokenText(params.get('lbx_priority') || '');

    const form = root.querySelector('[data-lbx-filter-form]');
    if (!form) return false;

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      const item = getClientFilterItem(input);
      let shouldCheck = false;

      if (category && item.type === 'category') {
        shouldCheck = clientValueMatches(category, item, 'category');
      }

      if (!shouldCheck && sizes.length && item.type === 'options' && (item.filterLabel.includes('talla') || item.keyText.includes('option.talla') || item.keyText.includes('option.size'))) {
        const optionText = tokenText(`${item.label} ${item.value}`);
        shouldCheck = sizes.some((size) => optionText === size || optionText.includes(size));
      }

      if (!shouldCheck && disciplines.length && item.type === 'discipline') {
        shouldCheck = disciplines.some((discipline) => clientValueMatches(discipline, item, 'discipline'));
      }

      if (!shouldCheck && priority === 'stock' && item.type === 'availability') {
        shouldCheck = availabilityFilterIntent(item) === 'available';
      }

      if (shouldCheck) {
        input.checked = true;
        input.closest('.lbxcat-check, .lbxcat-color')?.classList.add('is-active');
        matched = true;
      }
    });

    const minInput = form.querySelector('[name*="filter.v.price.gte"], [name*="price.gte"], [name*="min"]');
    const maxInput = form.querySelector('[name*="filter.v.price.lte"], [name*="price.lte"], [name*="max"]');
    if (budget.min && minInput) { minInput.value = budget.min; matched = true; }
    if (budget.max && maxInput) { maxInput.value = budget.max; matched = true; }

    return matched;
  };

  const getMaterialKey = (label) => {
    const text = normalizeText(label).replace(/[.\s_\-/]/g, '');
    if (!text) return '';
    if (text.includes('carbon')) return 'carbono';
    if (
      text.includes('alumin') ||
      text.includes('alu') ||
      text.includes('alloy') ||
      text.includes('aleacion') ||
      text.includes('7005') ||
      text.includes('6061') ||
      text.includes('6066') ||
      text.includes('6069') ||
      text.includes('hydroformed') ||
      text.includes('hidroformado') ||
      text.startsWith('al')
    ) return 'aluminio';
    return '';
  };

  const syncMaterialButtons = (filter) => {
    if (!filter) return;
    const buttons = filter.querySelectorAll('[data-lbx-material-toggle]');
    buttons.forEach((button) => {
      const key = normalizeText(button.getAttribute('data-lbx-material-toggle'));
      const labels = Array.from(filter.querySelectorAll(`.lbxcat-check--material[data-lbx-material-key="${key}"]`));
      const active = labels.some((label) => label.querySelector('input')?.checked);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const normalizeMaterialFilters = (root) => {
    root.querySelectorAll('.lbxcat-filter--material').forEach((filter) => {
      const hasSwitch = !!filter.querySelector('[data-lbx-material-switch]');
      filter.querySelectorAll('.lbxcat-check--material').forEach((label) => {
        const key = label.getAttribute('data-lbx-material-key') || getMaterialKey(label.getAttribute('data-lbx-material-label') || label.querySelector('i')?.textContent || '');
        if (key) {
          label.dataset.lbxMaterialKey = key;
          label.hidden = true;
        }
        label.classList.toggle('is-active', !!label.querySelector('input')?.checked);
      });
      if (hasSwitch) {
        syncMaterialButtons(filter);
        return;
      }

      const groups = new Map();
      filter.querySelectorAll('.lbxcat-check--material').forEach((label) => {
        const text = getMaterialKey(label.getAttribute('data-lbx-material-label') || label.querySelector('i')?.textContent || '') || normalizeText(label.getAttribute('data-lbx-material-label') || label.querySelector('i')?.textContent || '');
        if (!text) return;
        if (!groups.has(text)) groups.set(text, []);
        groups.get(text).push(label);
      });
      groups.forEach((labels) => {
        const first = labels[0];
        const total = labels.reduce((sum, label) => sum + (Number(label.querySelector('em')?.textContent || '0') || 0), 0);
        const active = labels.some((label) => label.querySelector('input')?.checked);
        labels.forEach((label, index) => {
          label.classList.toggle('is-active', active);
          label.hidden = index > 0;
          label.dataset.lbxMaterialGroup = first.getAttribute('data-lbx-material-label') || first.querySelector('i')?.textContent || '';
        });
        const counter = first.querySelector('em');
        if (counter && total > 0) counter.textContent = String(total);
      });
    });
  };

  const syncMaterialGroup = (input) => {
    const label = input?.closest?.('.lbxcat-check--material');
    if (!label) return;
    const filter = label.closest('.lbxcat-filter--material');
    const group = label.dataset.lbxMaterialGroup || label.getAttribute('data-lbx-material-label') || label.querySelector('i')?.textContent || '';
    if (!filter || !group) return;
    filter.querySelectorAll('.lbxcat-check--material').forEach((item) => {
      const itemGroup = item.dataset.lbxMaterialGroup || item.getAttribute('data-lbx-material-label') || item.querySelector('i')?.textContent || '';
      if (normalizeText(itemGroup) !== normalizeText(group)) return;
      const itemInput = item.querySelector('input');
      if (itemInput) itemInput.checked = input.checked;
      item.classList.toggle('is-active', input.checked);
    });
    syncMaterialButtons(filter);
  };


  const preservePreviewParams = (url) => {
    const current = new URL(window.location.href);
    PRESERVE_PARAMS.forEach((key) => {
      if (!url.searchParams.has(key) && current.searchParams.has(key)) {
        url.searchParams.set(key, current.searchParams.get(key));
      }
    });
    if (getOfferMode() && !url.searchParams.has('lbx_offer')) url.searchParams.set('lbx_offer', '1');
    return url;
  };

  const buildUrlFromForm = (root, form) => {
    const base = new URL(window.location.href);
    const collectionUrl = root?.getAttribute('data-lbx-collection-url');
    if (collectionUrl) base.pathname = collectionUrl;

    const current = new URL(window.location.href);
    const keep = new URLSearchParams();
    PRESERVE_PARAMS.forEach((key) => {
      if (current.searchParams.has(key)) keep.set(key, current.searchParams.get(key));
    });

    base.search = '';
    keep.forEach((value, key) => base.searchParams.set(key, value));

    const data = new FormData(form);
    data.forEach((value, key) => {
      const clean = cleanFormValue(value);
      if (!clean) return;
      base.searchParams.append(key, clean);
    });

    if (getOfferMode()) base.searchParams.set('lbx_offer', '1');
    const materials = Array.from(getClientMaterialModes());
    if (materials.length) base.searchParams.set('lbx_material', materials.join(','));
    return base;
  };

  const syncClientMaterialFilter = (root) => {
    const active = getClientMaterialModes();
    const cards = Array.from(root.querySelectorAll('[data-lbx-product-card]'));
    const counts = { carbono: 0, aluminio: 0 };
    cards.forEach((card) => {
      const key = normalizeText(card.getAttribute('data-lbx-material') || '');
      if (key === 'carbono') counts.carbono += 1;
      if (key === 'aluminio') counts.aluminio += 1;
    });
    root.querySelectorAll('[data-lbx-client-material-key]').forEach((label) => {
      const key = normalizeText(label.getAttribute('data-lbx-client-material-key'));
      const input = label.querySelector('input');
      const isActive = active.has(key);
      label.classList.toggle('is-active', isActive);
      if (input) input.checked = isActive;
      label.hidden = key === 'carbono' ? counts.carbono === 0 : key === 'aluminio' ? counts.aluminio === 0 : false;
    });
    root.querySelectorAll('[data-lbx-material-count]').forEach((counter) => {
      const key = normalizeText(counter.getAttribute('data-lbx-material-count'));
      counter.textContent = String(counts[key] || 0);
    });
  };

  const updateLiveState = (root) => {
    const liveSearch = root.querySelector('[data-lbx-live-search]');
    const visibleCount = root.querySelector('[data-lbx-visible-count]');
    const liveEmpty = root.querySelector('[data-lbx-live-empty]');
    const offerEmpty = root.querySelector('[data-lbx-offer-empty]');
    const query = liveSearch?.value || '';
    const offerActive = getOfferMode();
    const materialActive = getClientMaterialModes();
    let visible = 0;
    let saleVisible = 0;

    root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
      const searchable = card.getAttribute('data-lbx-search') || '';
      const material = normalizeText(card.getAttribute('data-lbx-material'));
      const matchesSearch = smartSearchMatches(searchable, query);
      const matchesMaterial = materialActive.size === 0 || materialActive.has(material);
      const isSale = card.getAttribute('data-lbx-sale') === 'true';
      card.classList.toggle('is-search-hidden', !(matchesSearch && matchesMaterial));
      if (matchesSearch && matchesMaterial && (!offerActive || isSale)) visible += 1;
      if (matchesSearch && matchesMaterial && isSale) saleVisible += 1;
    });

    if (visibleCount) visibleCount.textContent = String(visible);
    if (liveEmpty) liveEmpty.hidden = !(query && visible === 0);
    if (offerEmpty) offerEmpty.hidden = !(offerActive && saleVisible === 0);
  };

  const syncOfferMode = (root) => {
    const active = getOfferMode();
    root.classList.toggle('is-offer-mode', active);
    root.querySelectorAll('[data-lbx-offer-toggle]').forEach((button) => {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = button.querySelector('b');
      if (label) label.textContent = getCatalogLabel(root, 'offers-only', 'Offers only');
    });
    updateLiveState(root);
  };

  const normalizeView = (value) => value === 'list' ? 'list' : 'grid';
  const setView = (root, mode, persist = true) => {
    const next = normalizeView(mode);
    root.setAttribute('data-lbx-view-mode', next);
    root.classList.toggle('is-view-list', next === 'list');
    root.classList.toggle('is-view-grid', next === 'grid');
    root.querySelectorAll('[data-lbx-view]').forEach((button) => {
      const active = button.dataset.lbxView === next;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (persist) {
      try {
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
        if (!isMobile) window.localStorage.setItem(`${STORAGE_KEY}:desktop`, next);
      } catch (error) {}
    }
  };

  const currentView = () => {
    try {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
      if (isMobile) return 'list';

      const desktopKey = `${STORAGE_KEY}:desktop`;
      const stored = window.localStorage.getItem(desktopKey) || window.localStorage.getItem(STORAGE_KEY);
      if (stored) return normalizeView(stored);

      return 'grid';
    } catch (error) {
      return 'grid';
    }
  };

  let currentRequestController = null;

  const getOpenFilterKeys = (root) => Array.from(root.querySelectorAll('[data-lbx-filter][open]'))
    .map((filter) => filter.getAttribute('data-lbx-filter-key') || filter.getAttribute('data-lbx-filter-label') || '')
    .filter(Boolean);

  const restoreFilterState = (root, openKeys = []) => {
    const wanted = new Set(openKeys);
    root.querySelectorAll('[data-lbx-filter]').forEach((filter) => {
      const key = filter.getAttribute('data-lbx-filter-key') || filter.getAttribute('data-lbx-filter-label') || '';
      if (filter.hasAttribute('data-lbx-filter-priority') || wanted.has(key)) filter.setAttribute('open', '');
    });
  };

  const hydrateCards = (root) => {
    root.querySelectorAll('[data-lbx-product-card]').forEach((card, index) => {
      card.style.transitionDelay = `${Math.min(index * 14, 150)}ms`;
    });
  };



  let lbxActiveMobileFilterRoot = null;

  const getVisibleHeaderBottom = () => {
    const selectors = [
      'header',
      '.shopify-section-header',
      '.section-header',
      '.header-wrapper',
      '.site-header',
      '#shopify-section-header',
      '#shopify-section-sections--header'
    ];

    let bottom = 0;

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        const styles = window.getComputedStyle(element);
        if (styles.display === 'none' || styles.visibility === 'hidden') return;

        const rect = element.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return;

        const isTopHeader = rect.top <= 140 && rect.bottom > 0;
        const isSticky = styles.position === 'fixed' || styles.position === 'sticky';

        if (isTopHeader || isSticky) bottom = Math.max(bottom, rect.bottom);
      });
    });

    return Math.max(0, Math.ceil(bottom));
  };

  const setMobileFilterViewportVars = (root) => {
    if (!root) return;

    const isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    if (!isMobile) {
      root.style.removeProperty('--lbx-mobile-filter-top');
      root.style.removeProperty('--lbx-mobile-filter-height');
      return;
    }

    const headerBottom = getVisibleHeaderBottom();
    const top = Math.max(8, headerBottom + 8);
    const height = Math.max(260, window.innerHeight - top - 8);

    root.style.setProperty('--lbx-mobile-filter-top', `${top}px`);
    root.style.setProperty('--lbx-mobile-filter-height', `${height}px`);
  };

  const ensureBodyMobileFilterCloseButton = (root) => {
    if (!root) return;

    const isMobile = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    if (!isMobile) return;

    lbxActiveMobileFilterRoot = root;
    setMobileFilterViewportVars(root);

    let close = document.querySelector('[data-lbx-body-close-filters]');
    if (!close) {
      close = document.createElement('button');
      close.type = 'button';
      close.className = 'lbxcat-body-filter-close';
      close.setAttribute('data-lbx-body-close-filters', '');
      close.setAttribute('aria-label', getCatalogLabel(root, 'close-filters', 'Close filters'));
      close.innerHTML = '×';

      close.addEventListener('click', (event) => {
        event.preventDefault();
        const targetRoot = lbxActiveMobileFilterRoot || document.querySelector('[data-lbx-catalog].is-filter-open');
        if (targetRoot) closeFilterPanel(targetRoot);
      });

      document.body.appendChild(close);
    }

    const top = Number((root.style.getPropertyValue('--lbx-mobile-filter-top') || '').replace('px', '')) || (getVisibleHeaderBottom() + 8);
    close.style.setProperty('--lbx-body-filter-close-top', `${Math.max(16, top + 14)}px`);
    close.hidden = false;
    close.classList.add('is-visible');
  };

  const hideBodyMobileFilterCloseButton = () => {
    const close = document.querySelector('[data-lbx-body-close-filters]');
    if (!close) return;

    close.classList.remove('is-visible');
    close.hidden = true;
    lbxActiveMobileFilterRoot = null;
  };


  const ensureMobileFilterCloseButton = (root) => {
    const panel = root?.querySelector?.('[data-lbx-filter-panel], .lbxcat-filters');
    if (!panel) return;

    let close = panel.querySelector('[data-lbx-close-filters]');
    if (!close) {
      close = document.createElement('button');
      close.type = 'button';
      close.className = 'lbxcat-filters__close lbxcat-mobile-filter-close';
      close.setAttribute('data-lbx-close-filters', '');
      close.setAttribute('aria-label', getCatalogLabel(root, 'close-filters', 'Close filters'));
      close.innerHTML = '×';
      panel.prepend(close);
    } else {
      close.classList.add('lbxcat-mobile-filter-close');
      close.setAttribute('aria-label', close.getAttribute('aria-label') || getCatalogLabel(root, 'close-filters', 'Close filters'));
    }
  };


  const closeFilterPanel = (root) => {
    root.classList.remove('is-filter-open');
    root.style.removeProperty('--lbx-mobile-filter-top');
    root.style.removeProperty('--lbx-mobile-filter-height');
    document.body.classList.remove('lbxcat-filter-open');
    document.documentElement.classList.remove('lbxcat-filter-open');
    hideBodyMobileFilterCloseButton();
  };



  const getClientFilterItem = (input) => {
    const key = input?.name || '';
    const filter = input?.closest?.('[data-lbx-filter]');
    const filterLabelRaw = filter?.getAttribute('data-lbx-filter-label') || filter?.querySelector('summary span')?.textContent || '';
    const optionLabelRaw = input?.closest?.('label')?.querySelector('i')?.textContent || input?.value || '';
    const filterText = normalizeText(filterLabelRaw);
    const keyText = normalizeText(key);
    const label = normalizeText(optionLabelRaw);
    const value = normalizeText(input?.value || '');
    let type = '';

    if ((filterText.includes('recorrido') && (filterText.includes('suspension') || filterText.includes('suspensión'))) || keyText.includes('recorrido_suspension') || keyText.includes('recorrido-suspension')) type = 'travel';
    else if (filterText.includes('color') || filterText.includes('colour') || keyText.includes('color') || keyText.includes('colour') || keyText.includes('option.color')) type = 'color';
    else if (filterText.includes('motor') || keyText.includes('motor')) type = 'motor';
    else if (filterText.includes('bateria') || filterText.includes('battery') || keyText.includes('bateria') || keyText.includes('battery')) type = 'battery';
    else if (filterText.includes('suspension') || filterText.includes('suspensión') || keyText.includes('suspension')) type = 'suspension';
    else if (filterText.includes('cuadro') || filterText.includes('material') || keyText.includes('cuadro') || keyText.includes('material')) type = 'frame';
    else if (filterText.includes('categoria') || filterText.includes('categor') || keyText.includes('badge_categoria') || keyText.includes('categoria')) type = 'category';
    else if (filterText.includes('modalidad') || filterText.includes('disciplina') || filterText.includes('uso principal') || keyText.includes('modalidad') || keyText.includes('disciplina') || keyText.includes('uso_principal')) type = 'discipline';
    else if (filterText.includes('marca') || filterText.includes('brand') || keyText.includes('vendor') || keyText.includes('marca')) type = 'brand';
    else if (filterText.includes('disponibilidad') || filterText.includes('availability') || keyText.includes('availability') || keyText.includes('disponibilidad')) type = 'availability';
    else if (keyText.includes('filter.v.option') || keyText.includes('option.')) type = 'options';

    return { key, keyText, label, value, type, filterLabel: filterText, input };
  };

  const getCheckedClientFilterItems = (root) => Array.from(root.querySelectorAll('[data-lbx-filter-form] input[type="checkbox"]:checked'))
    .map(getClientFilterItem)
    .filter((item) => item && item.type);

  const filterGroupKey = (item) => {
    const filter = item?.input?.closest?.('[data-lbx-filter]');
    return filter?.getAttribute('data-lbx-filter-key') || filter?.getAttribute('data-lbx-filter-label') || item?.key || item?.type || '';
  };

  const isSizeFilterItem = (item) => {
    const text = tokenText(`${item?.filterLabel || ''} ${item?.keyText || ''} ${item?.label || ''}`);
    return text.includes('talla') || text.includes('size') || text.includes('option talla') || text.includes('option size');
  };

  const canonicalClientSize = (value) => {
    const text = tokenText(value);
    if (/(^| )xxs( |$)/.test(text)) return 'xxs';
    if (/(^| )xs( |$)/.test(text)) return 'xs';
    if (/(^| )xxl( |$)/.test(text)) return 'xxl';
    if (/(^| )xl( |$)/.test(text)) return 'xl';
    if (/(^| )l( |$)/.test(text)) return 'l';
    if (/(^| )m( |$)/.test(text)) return 'm';
    if (/(^| )s( |$)/.test(text)) return 's';
    if (/(^| )unica( |$)/.test(text) || /(^| )unico( |$)/.test(text)) return 'unica';
    return text;
  };

  const getCardVariantFilterRecords = (card) => Array.from(card.querySelectorAll('[data-lbx-variant-stock]')).map((node) => ({
    options: node.getAttribute('data-lbx-variant-options') || '',
    color: node.getAttribute('data-lbx-variant-color') || '',
    battery: node.getAttribute('data-lbx-variant-battery') || '',
    motor: node.getAttribute('data-lbx-variant-motor') || '',
    availability: node.getAttribute('data-lbx-variant-availability') || '',
    ownStock: Number(node.getAttribute('data-lbx-variant-own-stock') || '0'),
    supplierStock: Number(node.getAttribute('data-lbx-variant-supplier-stock') || '0')
  }));

  const clientGroupUsesVariant = (values = []) => {
    const type = values[0]?.type || '';
    return type === 'options' ||
      type === 'color' ||
      type === 'availability' ||
      type === 'battery' ||
      type === 'motor' ||
      values.some(isSizeFilterItem);
  };

  const variantRecordValue = (record, type) => {
    if (type === 'color') return `${record.color} ${record.options}`;
    if (type === 'battery') return `${record.battery} ${record.options}`;
    if (type === 'motor') return record.motor;
    if (type === 'availability') return record.availability;
    return record.options;
  };

  const variantRecordMatchesClientItem = (record, item, type) => {
    const value = variantRecordValue(record, type);

    if (isSizeFilterItem(item)) {
      const wanted = canonicalClientSize(item.label || item.value || '');
      if (!wanted) return true;
      const availableSizes = new Set(tokenText(record.options).split(/\s+/).filter(Boolean).map(canonicalClientSize));
      return availableSizes.has(wanted);
    }

    return clientValueMatches(value, item, type);
  };

  const getEligibleInputsInFilter = (filter) => {
    if (!filter) return [];

    return Array.from(filter.querySelectorAll('input[type="checkbox"], input[type="radio"]')).filter((input) => {
      const label = input.closest('.lbxcat-check, .lbxcat-color');
      if (input.disabled) return false;
      if (label?.hidden || label?.classList?.contains('is-client-disabled')) return false;
      return true;
    });
  };

  const allVisibleOptionsSelectedInFilter = (item) => {
    const filter = item?.input?.closest?.('[data-lbx-filter]');
    const inputs = getEligibleInputsInFilter(filter);

    if (inputs.length <= 1) return false;
    return inputs.every((input) => input.checked);
  };

  const allKnownSizesSelected = (items = []) => {
    const selected = new Set(items.filter(isSizeFilterItem).map((item) => tokenText(item.label || item.value || '')).filter(Boolean));
    if (!selected.size) return false;

    const canonical = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'unica', 'unico'];
    const selectedCanonical = canonical.filter((size) => selected.has(size));

    // If the user checks the whole standard size set, size should behave like no restriction.
    // This is generic for desktop, tablet and mobile, and prevents false zero-result states.
    return selectedCanonical.length >= 5 && (selected.has('s') || selected.has('m') || selected.has('l')) && (selected.has('xl') || selected.has('unica') || selected.has('unico'));
  };

  const getCardColorFilterValue = (card) => {
    return [
      card.getAttribute('data-lbx-color') || '',
      card.getAttribute('data-lbx-options') || '',
      card.getAttribute('data-lbx-search') || '',
      ...Array.from(card.querySelectorAll('[data-lbx-variant-color-images] [data-lbx-color-key], [data-lbx-variant-color-images] [data-lbx-color-label]')).map((node) => [
        node.getAttribute('data-lbx-color-key') || '',
        node.getAttribute('data-lbx-color-label') || ''
      ].join(' ')),
      ...Array.from(card.querySelectorAll('[data-lbx-color-media-map] [data-lbx-color-media-key], [data-lbx-color-media-map] [data-lbx-color-media-label]')).map((node) => [
        node.getAttribute('data-lbx-color-media-key') || '',
        node.getAttribute('data-lbx-color-media-label') || ''
      ].join(' ')),
      ...Array.from(card.querySelectorAll('[data-lbx-card-color-swatch]')).map((node) => [
        node.getAttribute('data-lbx-color-key') || '',
        node.getAttribute('data-lbx-color-label') || '',
        node.getAttribute('aria-label') || ''
      ].join(' '))
    ].join(' ');
  };

  const getCardValueForFilterType = (card, type, item = null) => {
    let cardValue = type === 'color' ? getCardColorFilterValue(card) : (card.getAttribute(`data-lbx-${type}`) || '');

    if (type === 'options') {
      cardValue = [
        card.getAttribute('data-lbx-options') || '',
        card.getAttribute('data-lbx-battery') || '',
        card.getAttribute('data-lbx-title') || '',
        card.getAttribute('data-lbx-search') || ''
      ].join(' ');
    }

    if (type === 'brand') {
      cardValue = [card.getAttribute('data-lbx-brand') || '', card.getAttribute('data-lbx-search') || ''].join(' ');
    }

    if (!cardValue && isSizeFilterItem(item)) {
      cardValue = [card.getAttribute('data-lbx-options') || '', card.getAttribute('data-lbx-search') || '', card.getAttribute('data-lbx-title') || ''].join(' ');
    }

    return cardValue;
  };

  const cardMatchesFilterItems = (card, items, ignoreTypes = new Set()) => {
    const groups = {};
    items.forEach((item) => {
      if (!item.type || ignoreTypes.has(item.type)) return;
      const key = filterGroupKey(item);
      if (!key) return;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });

    const activeGroups = Object.values(groups).filter((values) => {
      if (!values.length) return false;

      // Selecting every visible option is equivalent to removing that restriction.
      if (values.some(allVisibleOptionsSelectedInFilter)) return false;

      // The same applies to the complete/common size universe.
      if (values.some(isSizeFilterItem) && allKnownSizesSelected(values)) return false;

      return true;
    });

    const variantGroups = activeGroups.filter(clientGroupUsesVariant);
    const productGroups = activeGroups.filter((values) => !clientGroupUsesVariant(values));

    for (const values of productGroups) {
      const type = values[0]?.type || '';
      if (!type) continue;
      const cardValue = getCardValueForFilterType(card, type, values[0]);
      if (!values.some((item) => clientValueMatches(cardValue, item, type))) return false;
    }

    if (!variantGroups.length) return true;

    const variants = getCardVariantFilterRecords(card);
    if (variants.length) {
      const hasSizeGroup = variantGroups.some((values) => values.some(isSizeFilterItem));
      const hasAvailabilityGroup = variantGroups.some((values) => (values[0]?.type || '') === 'availability');

      return variants.some((variantRecord) => {
        const matchesSelectedVariantFilters = variantGroups.every((values) => {
          const type = values[0]?.type || '';
          return values.some((item) => variantRecordMatchesClientItem(variantRecord, item, type));
        });

        if (!matchesSelectedVariantFilters) return false;

        // Selecting a size means “this exact size is physically available now”.
        // Supplier / reservation stock must NOT make a size pass this filter.
        // This prevents a product from appearing for talla S when S is only
        // “bajo pedido” or sold out while another size has stock.
        if (hasSizeGroup && !hasAvailabilityGroup) {
          return Number(variantRecord.ownStock || 0) > 0;
        }

        return true;
      });
    }

    // Compatibility fallback for old cards without the variant map.
    for (const values of variantGroups) {
      const type = values[0]?.type || '';
      const cardValue = getCardValueForFilterType(card, type, values[0]);
      if (!cardValue && values.some(isSizeFilterItem)) continue;
      if (!values.some((item) => clientValueMatches(cardValue, item, type))) return false;
    }

    const hasFallbackSizeGroup = variantGroups.some((values) => values.some(isSizeFilterItem));
    const hasFallbackAvailabilityGroup = variantGroups.some((values) => (values[0]?.type || '') === 'availability');
    if (hasFallbackSizeGroup && !hasFallbackAvailabilityGroup) {
      // Old cards without per-variant stock cannot prove that the requested
      // size is physically available. Fail closed instead of showing a false positive.
      return false;
    }

    return true;
  };

  const syncDependentFilterOptions = (root) => {
    const checkedItems = getCheckedClientFilterItems(root);
    const categoryItems = checkedItems.filter((item) => item.type === 'category');

    const disciplineFilters = Array.from(root.querySelectorAll('[data-lbx-filter]')).filter((filter) => {
      const filterText = normalizeText(filter.getAttribute('data-lbx-filter-label') || filter.querySelector('summary span')?.textContent || '');
      return filterText.includes('modalidad') || filterText.includes('disciplina') || filterText.includes('uso principal');
    });

    disciplineFilters.forEach((filter) => {
      filter.querySelectorAll('label input[type="checkbox"]').forEach((input) => {
        const label = input.closest('label');
        const item = getClientFilterItem(input);
        if (!label || item.type !== 'discipline') return;

        let count = 0;
        root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
          const categoryOk = categoryItems.length === 0 || categoryItems.some((categoryItem) => clientValueMatches(card.getAttribute('data-lbx-category') || '', categoryItem, 'category'));
          const disciplineOk = clientValueMatches(card.getAttribute('data-lbx-discipline') || '', item, 'discipline');
          if (categoryOk && disciplineOk) count += 1;
        });

        const shouldHide = count === 0 && categoryItems.length > 0;
        if (shouldHide && input.checked) {
          input.checked = false;
          label.classList.remove('is-active');
        }

        label.classList.toggle('is-client-disabled', shouldHide);
        label.hidden = shouldHide;

        const counter = label.querySelector('em');
        if (counter) counter.textContent = String(count);
      });
    });
  };



  const setCardVisible = (card, visible) => {
    card.classList.toggle('is-instant-hidden', !visible);
    card.hidden = !visible;
    card.style.display = visible ? '' : 'none';
  };

  const getSortMode = (root) => {
    const select = root.querySelector('[data-lbx-sort-form] select[name="sort_by"]');
    const mode = select?.value || '';
    if (!mode || mode === 'manual' || mode === 'best-selling' || mode === 'most-relevant' || mode === 'relevance') return 'manual';
    return mode;
  };

  const parseTitle = (card) => tokenText(card.getAttribute('data-lbx-title') || card.querySelector('.lbxcat-card__title')?.textContent || '');

  const refreshBrandGroupHeadings = (root, list, cards, mode) => {
    list.querySelectorAll('[data-lbx-brand-group-heading]').forEach((heading) => heading.remove());
    if (root.getAttribute('data-lbx-group-by-brand') !== 'true' || mode !== 'manual') return;

    let lastBrand = null;
    cards.forEach((card) => {
      if (card.hidden || card.style.display === 'none' || card.classList.contains('is-instant-hidden')) return;
      const brandKey = tokenText(card.getAttribute('data-lbx-brand') || card.getAttribute('data-lbx-brand-label') || '');
      if (!brandKey || brandKey === lastBrand) return;
      lastBrand = brandKey;
      const label = String(card.getAttribute('data-lbx-brand-label') || card.getAttribute('data-lbx-brand') || '').trim();
      if (!label) return;
      const heading = document.createElement('h3');
      heading.className = 'lbxcat-brand-group-heading';
      heading.setAttribute('data-lbx-brand-group-heading', '');
      heading.textContent = label;
      list.insertBefore(heading, card);
    });
  };

  const sortVisibleCards = (root) => {
    const list = root.querySelector('[data-lbx-product-list], .lbxcat-products');
    if (!list) return;
    const mode = getSortMode(root);
    const cards = Array.from(list.querySelectorAll('[data-lbx-product-card]'));
    cards.forEach((card, index) => {
      if (!card.dataset.lbxOriginalIndex) card.dataset.lbxOriginalIndex = String(index);
    });

    const getPrice = (card) => Number(card.getAttribute('data-lbx-price') || '0');
    const getCreated = (card) => Number(card.getAttribute('data-lbx-created') || '0');
    const getIndex = (card, index) => {
      if (!card.dataset.lbxOriginalIndex) card.dataset.lbxOriginalIndex = String(index);
      return Number(card.dataset.lbxOriginalIndex || '0');
    };
    const brandGrouping = root.getAttribute('data-lbx-group-by-brand') === 'true' && mode === 'manual';
    const brandRanks = new Map();
    if (brandGrouping) {
      cards.slice().sort((a,b) => getIndex(a,0) - getIndex(b,0)).forEach((card) => {
        const brand = tokenText(card.getAttribute('data-lbx-brand') || card.getAttribute('data-lbx-brand-label') || '');
        if (brand && !brandRanks.has(brand)) brandRanks.set(brand, brandRanks.size);
      });
    }

    cards.sort((a, b) => {
      if (mode === 'price-ascending') return getPrice(a) - getPrice(b);
      if (mode === 'price-descending') return getPrice(b) - getPrice(a);
      if (mode === 'title-ascending') return parseTitle(a).localeCompare(parseTitle(b));
      if (mode === 'title-descending') return parseTitle(b).localeCompare(parseTitle(a));
      if (mode === 'created-ascending') return getCreated(a) - getCreated(b);
      if (mode === 'created-descending') return getCreated(b) - getCreated(a);
      if (brandGrouping) {
        const aBrand = tokenText(a.getAttribute('data-lbx-brand') || a.getAttribute('data-lbx-brand-label') || '');
        const bBrand = tokenText(b.getAttribute('data-lbx-brand') || b.getAttribute('data-lbx-brand-label') || '');
        const rankDiff = (brandRanks.get(aBrand) ?? 9999) - (brandRanks.get(bBrand) ?? 9999);
        if (rankDiff) return rankDiff;
      }
      return getIndex(a, 0) - getIndex(b, 0);
    });

    cards.forEach((card) => list.appendChild(card));
    refreshBrandGroupHeadings(root, list, cards, mode);
  };



  const quickValueFromElement = (el) => {
    const raw = el?.dataset?.lbxQuickValue
      || el?.getAttribute?.('data-lbx-quick-value')
      || el?.textContent
      || '';
    const text = tokenText(raw.replace(/\d+$/g, '').replace('×', '').trim());
    if (!text || text === 'todo') return '';
    if (text.includes('hibrida') || text.includes('hibrido') || text.includes('trekking')) return 'trekking';
    if (text.includes('montana')) return 'montana';
    return text;
  };

  const findCategoryInputs = (root) => {
    const form = root.querySelector('[data-lbx-filter-form]');
    return Array.from(form?.querySelectorAll('input[type="checkbox"]') || []).filter((input) => {
      const item = getClientFilterItem(input);
      return item.type === 'category';
    });
  };

  const setQuickCategory = (root, quickValue) => {
    const inputs = findCategoryInputs(root);
    inputs.forEach((input) => {
      const item = getClientFilterItem(input);
      const checked = quickValue ? clientValueMatches(quickValue, item, 'category') : false;
      input.checked = checked;
      input.closest('.lbxcat-check, .lbxcat-color')?.classList.toggle('is-active', checked);
    });

    syncDependentFilterOptions(root);
    applyClientOnlyFilters(root);
    updateClientActiveChips(root);
    syncQuickChips(root);
  };

  const syncQuickChips = (root) => {
    const activeCategory = findCategoryInputs(root)
      .filter((input) => input.checked)
      .map((input) => getClientFilterItem(input))
      .find(Boolean);

    const activeValue = activeCategory ? valueAliases(activeCategory.label || activeCategory.value || '', 'category') : [];
    const activeCanonicalValue = activeCategory
      ? normalizeUrlCategory(activeCategory.label || activeCategory.value || '')
      : '';
    root.querySelectorAll('.lbxcat-quick a, .lbxcat-quick button, .lbxcat-chip').forEach((chip) => {
      const quickValue = quickValueFromElement(chip);
      const isAll = !quickValue;
      const quickCanonicalValue = normalizeUrlCategory(quickValue);
      const active = isAll
        ? !activeCategory
        : activeValue.includes(quickValue) || activeCanonicalValue === quickCanonicalValue;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };



  const isColorFilterInput = (input) => {
    const item = getClientFilterItem(input);
    return item.type === 'color';
  };

  const selectedColorFilter = (root) => {
    const form = root.querySelector('[data-lbx-filter-form]');
    const input = Array.from(form?.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked') || [])
      .find(isColorFilterInput);
    return input ? getClientFilterItem(input) : null;
  };

  const syncSingleColorSelection = (root, changedInput) => {
    if (!changedInput || !isColorFilterInput(changedInput) || !changedInput.checked) return;

    const filter = changedInput.closest('[data-lbx-filter]');
    const scope = filter || root.querySelector('[data-lbx-filter-form]');
    scope?.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      if (input === changedInput || !isColorFilterInput(input)) return;
      input.checked = false;
      input.closest('.lbxcat-check, .lbxcat-color')?.classList.remove('is-active');
    });

    changedInput.closest('.lbxcat-check, .lbxcat-color')?.classList.add('is-active');
  };

  const matchColorKey = (selected, key, label) => {
    const selectedTokens = valueAliases(selected.label || selected.value || '', 'color').map(tokenText);
    const keyText = tokenText(key || '');
    const labelText = tokenText(label || '');

    return selectedTokens.some((selectedToken) => {
      if (!selectedToken) return false;
      return keyText === selectedToken ||
        labelText === selectedToken ||
        keyText.includes(selectedToken) ||
        selectedToken.includes(keyText) ||
        labelText.includes(selectedToken) ||
        selectedToken.includes(labelText);
    });
  };

  const resetProductCardImage = (card) => {
    const img = card.querySelector('[data-lbx-primary-src]');
    if (!img) return;

    const original = img.getAttribute('data-lbx-original-primary-src') || img.getAttribute('data-lbx-primary-src');
    const originalHover = img.getAttribute('data-lbx-original-hover-src') || '';
    if (!original) return;

    card.querySelectorAll('[data-lbx-variant-color-images] [data-lbx-color-src]').forEach((item) => item.classList.remove('is-selected'));
    img.src = original;
    img.setAttribute('data-lbx-primary-src', original);
    if (originalHover) img.setAttribute('data-lbx-hover-src', originalHover);
    else img.removeAttribute('data-lbx-hover-src');
    img.classList.remove('is-variant-color-image');
  };


  const updateStoreAvailabilityLabel = (card) => {
    const label = card.querySelector('[data-lbx-store-availability], .lbxcat-card__availability');
    if (!label) return;

    // Estado a nivel PRODUCTO: no se recalcula por color/variante visible.
    // Prioridad: stock propio > stock proveedor > sin stock.
    const explicitStatus = card.getAttribute('data-lbx-product-stock-status');
    const ownStockTotal = Number(card.getAttribute('data-lbx-own-stock-total') || '0');
    const supplierStockTotal = Number(card.getAttribute('data-lbx-supplier-stock-total') || '0');
    let status = explicitStatus || card.getAttribute('data-lbx-product-stock-status') || card.getAttribute('data-lbx-availability') || 'sold-out';

    if (ownStockTotal > 0 || card.getAttribute('data-lbx-store-stock') === 'true') {
      status = 'in-stock';
    } else if (supplierStockTotal > 0 || card.getAttribute('data-lbx-supplier-stock') === 'true' || card.getAttribute('data-lbx-total-stock') === 'true') {
      status = 'supplier-stock';
    } else if (card.getAttribute('data-lbx-reservation-stock') === 'true') {
      status = 'reservation';
    } else {
      status = 'sold-out';
    }

    label.classList.toggle('is-in-stock', status === 'in-stock');
    label.classList.toggle('is-muted', status !== 'in-stock');
    label.classList.toggle('is-supplier-stock', status === 'supplier-stock');
    label.classList.toggle('is-reservation', status === 'reservation');
    label.classList.toggle('is-out-of-stock', status === 'sold-out');

    const storeText = document.querySelector('[data-lbx-catalog]')?.getAttribute('data-lbx-stock-label-store') || 'Envío en 24/48h';
    const supplierText = document.querySelector('[data-lbx-catalog]')?.getAttribute('data-lbx-stock-label-supplier') || 'Entrega en 10 días laborables';
    const reservationText = document.querySelector('[data-lbx-catalog]')?.getAttribute('data-lbx-stock-label-reservation') || 'Available by reservation';
    const outText = document.querySelector('[data-lbx-catalog]')?.getAttribute('data-lbx-stock-label-out') || 'Out of stock';

    if (status === 'in-stock') label.textContent = storeText;
    else if (status === 'supplier-stock') label.textContent = supplierText;
    else if (status === 'reservation') label.textContent = reservationText;
    else label.textContent = outText;

    card.setAttribute('data-lbx-availability', status);
  };

  const updateStoreAvailabilityForSelectedColor = (root) => {
    root.querySelectorAll('[data-lbx-product-card]').forEach((card) => updateStoreAvailabilityLabel(card));
  };




  const colorNameToCSS = (label = '') => {
    const text = tokenText(label);
    const has = (...keys) => keys.some((key) => text.includes(key));

    if (has('elderberry', 'aubergine', 'berenjena')) return '#5b2f5f';
    if (has('lavender', 'lavanda', 'lila', 'lilac')) return '#8b6fc8';
    if (has('morado', 'morada', 'violeta', 'purple', 'violet', 'purpura', 'púrpura', 'amethyst')) return '#6f4aa2';
    if (has('rosa', 'pink', 'rose')) return '#d75b8c';
    if (has('petrol', 'teal', 'turquoise', 'turquesa', 'aqua')) return '#0f6f73';
    if (has('navy', 'marine', 'marino', 'azul marino', 'dunkelblau')) return '#172554';
    if (has('azul', 'blue', 'blau', 'bleu', 'blu')) return '#1d65d8';
    if (has('moss', 'musgo', 'sage', 'salvia', 'argile', 'khaki')) return '#6f7c55';
    if (has('verde', 'green', 'grun', 'gruen', 'vert', 'olive', 'oliva')) return '#3f6f4b';
    if (has('burgundy', 'granate', 'burdeos', 'wine')) return '#6f1d2a';
    if (has('rojo', 'red', 'rot', 'rouge', 'rosso')) return '#b91c1c';
    if (has('naranja', 'orange', 'arancione')) return '#f97316';
    if (has('amarillo', 'yellow', 'gelb')) return '#f3c735';
    if (has('champagne', 'champan', 'champán')) return '#d8c3a5';
    if (has('beige', 'sand', 'arena', 'crema', 'cream', 'sable')) return '#d8c3a5';
    if (has('dorado', 'gold', 'oro')) return '#c8a24a';
    if (has('bronce', 'bronze')) return '#9a6b34';
    if (has('cobre', 'copper')) return '#b87333';
    if (has('marron', 'marrón', 'brown', 'braun', 'brun', 'cafe', 'café', 'chocolate')) return '#8b5a34';
    if (has('titanio', 'titanium')) return '#9a958d';
    if (has('plata', 'silver')) return '#c8ccd2';
    if (has('basalt', 'basalto', 'graphite', 'grafito', 'anthracite', 'antracita')) return '#2b2d31';
    if (has('gris', 'grey', 'gray', 'grau', 'grigio')) return '#8f949a';
    if (has('blanco', 'white', 'weiss', 'weiß', 'blanc', 'bianco')) return '#f7f7f2';
    if (has('negro', 'black', 'schwarz', 'noir', 'nero')) return '#15171c';

    return 'linear-gradient(135deg, #f8f5ef 0%, #b08d57 50%, #151515 100%)';
  };

  const selectedColorKey = (root) => {
    const selected = selectedColorFilter(root);
    return selected ? tokenText(selected.label || selected.value || '') : '';
  };

  const findFirstColorMediaSrc = (card, key, label = '') => {
    const pseudoSelected = { label: label || key, value: label || key };
    const matches = colorMediaMatches(card, pseudoSelected);
    return matches[0]?.getAttribute('data-lbx-color-media-src') || '';
  };

  const syncCardColorSwatches = (root = document) => {
    const scope = root.matches?.('[data-lbx-catalog]') ? root : (root.querySelector?.('[data-lbx-catalog]') || document);
    const activeKey = selectedColorKey(scope);

    scope.querySelectorAll?.('[data-lbx-product-card]').forEach((card) => {
      card.querySelectorAll('[data-lbx-card-color-swatch]').forEach((swatch) => {
        const label = swatch.getAttribute('data-lbx-swatch-label') || '';
        const key = tokenText(label || swatch.getAttribute('data-lbx-swatch-key') || '');
        const dot = swatch.querySelector('span');

        if (dot && !dot.style.background) {
          dot.style.background = colorNameToCSS(label);
        }

        const hasMedia = Boolean(findFirstColorMediaSrc(card, key, label));
        swatch.classList.toggle('is-unavailable-media', !hasMedia);
        swatch.classList.toggle('is-active', Boolean(activeKey && (activeKey === key || activeKey.includes(key) || key.includes(activeKey))));
      });
    });
  };

  const setCardImageToCurrentSelection = (card) => {
    const root = card.closest('[data-lbx-catalog]') || document;
    const selected = selectedColorFilter(root);
    if (!selected) {
      resetProductCardImage(card);
      updateStoreAvailabilityLabel(card, null);
      return;
    }

    const tempRoot = card.closest('[data-lbx-catalog]');
    if (tempRoot) updateProductImagesForSelectedColor(tempRoot);
  };

  const initCardColorSwatches = (root = document) => {
    const scope = root.matches?.('[data-lbx-catalog]') ? root : (root.querySelector?.('[data-lbx-catalog]') || document);

    scope.querySelectorAll?.('[data-lbx-card-color-swatch]').forEach((swatch) => {
      if (swatch.dataset.lbxSwatchReady === 'true') return;
      swatch.dataset.lbxSwatchReady = 'true';

      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });

    syncCardColorSwatches(scope);
  };

  const colorMediaMatches = (card, selected) => {
    if (!selected) return [];
    return Array.from(card.querySelectorAll('[data-lbx-color-media-map] [data-lbx-color-media-src]')).filter((item) => {
      return matchColorKey(selected, item.getAttribute('data-lbx-color-media-key'), item.getAttribute('data-lbx-color-media-label'));
    });
  };

  const colorMediaSources = (card, key, label = '') => {
    const pseudoSelected = { label: label || key, value: label || key };
    const sources = [];

    colorMediaMatches(card, pseudoSelected).forEach((item) => {
      const src = item.getAttribute('data-lbx-color-media-src') || '';
      if (!src) return;
      const normalized = normalizeImageUrl(src);
      if (sources.some((existing) => normalizeImageUrl(existing) === normalized)) return;
      sources.push(src);
    });

    return sources;
  };

  const clearTemporarySwatchImage = (card) => {
    const img = card.querySelector('[data-lbx-primary-src]');
    if (!img || img.getAttribute('data-lbx-temp-swatch-active') !== 'true') return;

    const primary = img.getAttribute('data-lbx-temp-return-primary') || '';
    const hover = img.getAttribute('data-lbx-temp-return-hover') || '';

    img.removeAttribute('data-lbx-temp-swatch-active');
    img.removeAttribute('data-lbx-temp-return-primary');
    img.removeAttribute('data-lbx-temp-return-hover');
    img.removeAttribute('data-lbx-temp-swatch-primary');
    img.removeAttribute('data-lbx-temp-swatch-hover');

    if (primary) {
      img.setAttribute('data-lbx-primary-src', primary);
      img.src = primary;
    }

    if (hover) img.setAttribute('data-lbx-hover-src', hover);
    else img.removeAttribute('data-lbx-hover-src');

    setCardImageToCurrentSelection(card);
  };

  const persistTemporarySwatchImage = (card) => {
    const img = card.querySelector('[data-lbx-primary-src]');
    if (!img || img.getAttribute('data-lbx-temp-swatch-active') !== 'true') return;

    const primary = img.getAttribute('data-lbx-temp-swatch-primary') || '';
    const hover = img.getAttribute('data-lbx-temp-swatch-hover') || '';

    img.removeAttribute('data-lbx-temp-swatch-active');
    img.removeAttribute('data-lbx-temp-return-primary');
    img.removeAttribute('data-lbx-temp-return-hover');
    img.removeAttribute('data-lbx-temp-swatch-primary');
    img.removeAttribute('data-lbx-temp-swatch-hover');

    if (primary) {
      img.setAttribute('data-lbx-primary-src', primary);
      img.src = primary;
    }

    if (hover) {
      img.setAttribute('data-lbx-hover-src', hover);
      preloadImage(hover);
    } else {
      img.removeAttribute('data-lbx-hover-src');
    }

    img.classList.add('is-variant-color-image');
  };

  const applyTemporarySwatchImage = (card, key, label = '') => {
    const img = card.querySelector('[data-lbx-primary-src]');
    if (!img) return false;

    const sources = colorMediaSources(card, key, label);
    const primary = sources[0] || '';
    const hover = sources.find((src) => normalizeImageUrl(src) !== normalizeImageUrl(primary)) || '';

    if (!primary) return false;

    if (img.getAttribute('data-lbx-temp-swatch-active') !== 'true') {
      img.setAttribute('data-lbx-temp-return-primary', img.getAttribute('data-lbx-primary-src') || img.currentSrc || img.src || '');
      img.setAttribute('data-lbx-temp-return-hover', img.getAttribute('data-lbx-hover-src') || '');
    }

    img.setAttribute('data-lbx-temp-swatch-active', 'true');
    img.setAttribute('data-lbx-temp-swatch-primary', primary);
    if (hover) img.setAttribute('data-lbx-temp-swatch-hover', hover);
    else img.removeAttribute('data-lbx-temp-swatch-hover');

    img.setAttribute('data-lbx-primary-src', primary);
    if (hover) {
      img.setAttribute('data-lbx-hover-src', hover);
      preloadImage(hover);
    } else {
      img.removeAttribute('data-lbx-hover-src');
    }

    preloadImage(primary);
    img.src = primary;
    return true;
  };




  const initDelegatedCardColorSwatches = (root = document) => {
    const catalog = root.matches?.('[data-lbx-catalog]') ? root : (root.querySelector?.('[data-lbx-catalog]') || document);
    if (catalog.dataset.lbxDelegatedSwatchesReady === 'true') return;
    catalog.dataset.lbxDelegatedSwatchesReady = 'true';

    catalog.addEventListener('pointerover', (event) => {
      const swatch = event.target.closest?.('[data-lbx-card-color-swatch]');
      if (!swatch || !catalog.contains(swatch)) return;

      const card = swatch.closest('[data-lbx-product-card]');
      if (!card) return;

      const label = swatch.getAttribute('data-lbx-swatch-label') || '';
      const key = swatch.getAttribute('data-lbx-swatch-key') || label;
      applyTemporarySwatchImage(card, key, label);
    });

    catalog.addEventListener('pointerout', (event) => {
      const swatch = event.target.closest?.('[data-lbx-card-color-swatch]');
      if (!swatch || !catalog.contains(swatch)) return;
      if (swatch.contains(event.relatedTarget)) return;

      const card = swatch.closest('[data-lbx-product-card]');
      const media = swatch.closest('[data-lbx-product-media]');

      if (!card) return;

      // If the cursor remains inside the colour selector pill, keep the first image
      // of that colour. The second image should only appear when moving into the
      // real photo area, not over the selector background.
      const swatchGroup = swatch.closest('[data-lbx-color-swatches]');
      if (swatchGroup && swatchGroup.contains(event.relatedTarget)) {
        const img = card.querySelector('[data-lbx-primary-src]');
        const primary = img?.getAttribute('data-lbx-temp-swatch-primary') || img?.getAttribute('data-lbx-primary-src') || '';
        if (img && primary) img.src = primary;
        return;
      }

      // If the cursor moves from the colour selector to the white photo area,
      // keep the same colour active and show its second image if it exists.
      if (media && media.contains(event.relatedTarget)) {
        const img = card.querySelector('[data-lbx-primary-src]');
        const hover = img?.getAttribute('data-lbx-temp-swatch-hover') || img?.getAttribute('data-lbx-hover-src') || '';
        const primary = img?.getAttribute('data-lbx-temp-swatch-primary') || img?.getAttribute('data-lbx-primary-src') || '';
        if (img && hover && normalizeImageUrl(hover) !== normalizeImageUrl(primary)) img.src = hover;
        return;
      }

      persistTemporarySwatchImage(card);
    });

    catalog.addEventListener('pointerout', (event) => {
      const swatchGroup = event.target.closest?.('[data-lbx-color-swatches]');
      if (!swatchGroup || !catalog.contains(swatchGroup)) return;
      if (swatchGroup.contains(event.relatedTarget)) return;

      const card = swatchGroup.closest('[data-lbx-product-card]');
      const media = swatchGroup.closest('[data-lbx-product-media]');
      if (!card) return;

      const img = card.querySelector('[data-lbx-primary-src]');
      if (!img) return;

      const primary = img.getAttribute('data-lbx-temp-swatch-primary') || img.getAttribute('data-lbx-primary-src') || '';
      const hover = img.getAttribute('data-lbx-temp-swatch-hover') || img.getAttribute('data-lbx-hover-src') || '';

      // Leaving the whole colour selector pill towards the product image:
      // keep the selected/previewed colour and show its second image.
      if (media && media.contains(event.relatedTarget)) {
        if (hover && primary && normalizeImageUrl(hover) !== normalizeImageUrl(primary)) {
          img.src = hover;
        } else if (primary) {
          img.src = primary;
        }
        return;
      }

      // Leaving the colour selector outside the photo area: keep the last colour
      // as the main image, so the card does not jump back to a different variant.
      persistTemporarySwatchImage(card);
    });

    catalog.addEventListener('click', (event) => {
      const swatch = event.target.closest?.('[data-lbx-card-color-swatch]');
      if (!swatch || !catalog.contains(swatch)) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    syncCardColorSwatches(catalog);
  };

  const updateProductImagesForSelectedColor = (root) => {
    const selected = selectedColorFilter(root);

    root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
      clearTemporarySwatchImage(card);
      const img = card.querySelector('[data-lbx-primary-src]');
      if (!img) return;

      if (!img.getAttribute('data-lbx-original-primary-src')) {
        img.setAttribute('data-lbx-original-primary-src', img.getAttribute('data-lbx-primary-src') || img.currentSrc || img.src || '');
      }
      if (!img.getAttribute('data-lbx-original-hover-src')) {
        img.setAttribute('data-lbx-original-hover-src', img.getAttribute('data-lbx-hover-src') || '');
      }

      if (!selected) {
        resetProductCardImage(card);
        updateStoreAvailabilityLabel(card, null);
        return;
      }

      const matches = Array.from(card.querySelectorAll('[data-lbx-variant-color-images] [data-lbx-color-key]')).filter((item) => {
        return matchColorKey(selected, item.getAttribute('data-lbx-color-key'), item.getAttribute('data-lbx-color-label'));
      });

      card.querySelectorAll('[data-lbx-variant-color-images] [data-lbx-color-src]').forEach((item) => item.classList.remove('is-selected'));

      const mediaMatches = colorMediaMatches(card, selected);
      const matchWithImage = matches.find((item) => item.getAttribute('data-lbx-color-src'));

      const uniqueMediaSources = [];
      mediaMatches.forEach((item) => {
        const mediaSrc = item.getAttribute('data-lbx-color-media-src') || '';
        if (!mediaSrc) return;
        const normalized = normalizeImageUrl(mediaSrc);
        if (uniqueMediaSources.some((existing) => normalizeImageUrl(existing) === normalized)) return;
        uniqueMediaSources.push(mediaSrc);
      });

      const variantSrc = matchWithImage?.getAttribute('data-lbx-color-src') || '';
      const src = variantSrc || uniqueMediaSources[0] || '';

      const hoverSrc = uniqueMediaSources.find((mediaSrc) => {
        return normalizeImageUrl(mediaSrc) !== normalizeImageUrl(src);
      }) || '';

      if (!matches.length || !src) {
        resetProductCardImage(card);
        updateStoreAvailabilityLabel(card, selected);
        return;
      }

      if (matchWithImage) matchWithImage.classList.add('is-selected');

      img.src = src;
      img.setAttribute('data-lbx-primary-src', src);
      preloadImage(src);

      if (hoverSrc) {
        img.setAttribute('data-lbx-hover-src', hoverSrc);
        preloadImage(hoverSrc);
      } else {
        img.removeAttribute('data-lbx-hover-src');
      }

      img.classList.add('is-variant-color-image');
      updateStoreAvailabilityLabel(card, selected);
    });

    syncCardColorSwatches(root);
  };



  const smartSearchMatches = (searchable, query) => {
    const haystack = tokenText(searchable || '');
    const terms = tokenText(query || '').split(/\s+/).filter(Boolean);
    if (!terms.length) return true;
    return terms.every((term) => haystack.includes(term));
  };

  const clearSearchAutoFilters = (root) => {
    root.querySelectorAll('[data-lbx-search-auto="true"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute('data-lbx-search-auto');
      input.closest('.lbxcat-check, .lbxcat-color')?.classList.remove('is-active');
    });
  };

  const searchTermMatchesFilterItem = (queryText, item) => {
    const query = tokenText(queryText || '');
    if (!query) return false;

    const label = tokenText(`${item.label || ''} ${item.value || ''}`);
    const labelTerms = label.split(/\s+/).filter(Boolean);
    const queryTerms = query.split(/\s+/).filter(Boolean);

    if (!labelTerms.length || !queryTerms.length) return false;

    const numericLabelTerms = labelTerms.filter((term) => /^\d+$/.test(term));
    if (numericLabelTerms.length && numericLabelTerms.some((term) => queryTerms.includes(term))) return true;

    const strongTerms = labelTerms.filter((term) => term.length >= 4 && !['hasta', 'desde', 'para', 'with', 'stock'].includes(term));
    if (strongTerms.length && strongTerms.every((term) => query.includes(term))) return true;

    if (label.length >= 4 && query.includes(label)) return true;

    return false;
  };

  const syncSearchAutoFilters = (root) => {
    const input = root.querySelector('[data-lbx-live-search]');
    const query = input?.value || '';

    clearSearchAutoFilters(root);
    if (!query.trim()) return;

    const allowedTypes = new Set(['battery', 'suspension', 'travel', 'frame', 'motor', 'category', 'discipline', 'brand', 'color']);

    root.querySelectorAll('[data-lbx-filter-form] input[type="checkbox"]').forEach((filterInput) => {
      if (filterInput.checked) return;

      const item = getClientFilterItem(filterInput);
      if (!allowedTypes.has(item.type)) return;
      if (!searchTermMatchesFilterItem(query, item)) return;

      filterInput.checked = true;
      filterInput.setAttribute('data-lbx-search-auto', 'true');
      filterInput.closest('.lbxcat-check, .lbxcat-color')?.classList.add('is-active');

      if (item.type === 'color') syncSingleColorSelection(root, filterInput);
    });

    syncDependentFilterOptions(root);
    syncQuickChips(root);
  };


  const applyClientOnlyFilters = (root) => {
    const form = root.querySelector('[data-lbx-filter-form]');
    const activeMaterials = getClientMaterialModes();
    const liveSearch = root.querySelector('[data-lbx-live-search]');
    const query = liveSearch?.value || '';
    const offerActive = getOfferMode();

    syncDependentFilterOptions(root);
    const checked = getCheckedClientFilterItems(root);

    const minInput = form?.querySelector('[name*="filter.v.price.gte"], [name*="price.gte"], [name*="min"]');
    const maxInput = form?.querySelector('[name*="filter.v.price.lte"], [name*="price.lte"], [name*="max"]');
    const minPrice = minInput ? Number(cleanFormValue(minInput.value) || '0') : 0;
    const maxPrice = maxInput && cleanFormValue(maxInput.value) ? Number(cleanFormValue(maxInput.value)) : Infinity;

    let visible = 0;
    root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
      let show = true;
      const searchable = card.getAttribute('data-lbx-search') || '';
      const price = Number(card.getAttribute('data-lbx-price') || '0');

      if (!smartSearchMatches(searchable, query)) show = false;
      if (offerActive && card.getAttribute('data-lbx-sale') !== 'true') show = false;
      if (activeMaterials.size && !activeMaterials.has(normalizeText(card.getAttribute('data-lbx-material') || ''))) show = false;
      if (show && (price < minPrice || price > maxPrice)) show = false;
      if (show && !cardMatchesFilterItems(card, checked)) show = false;

      setCardVisible(card, show);
      if (show) visible += 1;
    });

    const visibleCount = root.querySelector('[data-lbx-visible-count]');
    if (visibleCount) visibleCount.textContent = String(visible);
    sortVisibleCards(root);
    updateProductImagesForSelectedColor(root);
    syncCardColorSwatches(root);
  };


  const preserveViewportPosition = (root, fn) => {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    const active = document.activeElement;
    fn();
    if (!isMobileViewport() && !root?.classList?.contains('is-filter-open')) {
      requestAnimationFrame(() => {
        try { window.scrollTo({ top: y, left: 0, behavior: 'auto' }); } catch (e) { window.scrollTo(0, y); }
        try { active?.focus?.({ preventScroll: true }); } catch (e) {}
      });
    }
  };

  const updateClientActiveChips = (root) => {
    const active = root.querySelector('.lbxcat-active');
    if (!active) return;
    const labels = [];
    root.querySelectorAll('[data-lbx-filter-form] input[type="checkbox"]:checked').forEach((input) => {
      const text = input.closest('label')?.querySelector('i')?.textContent?.trim();
      if (text) labels.push(text);
    });
    const mats = Array.from(getClientMaterialModes());
    mats.forEach((m) => labels.push(m === 'carbono' ? getCatalogLabel(root, 'carbon', 'Carbon') : getCatalogLabel(root, 'aluminum', 'Aluminum')));
    active.innerHTML = labels.map((label) => `<span class="lbxcat-active__client-chip">${label}</span>`).join('');
  };


  const refreshCatalog = async (root, url, options = {}) => {
    if (CLIENT_ONLY_FILTERS) {
      if (!root) return;
      applyClientOnlyFilters(root);
      updateClientActiveChips(root);
      syncOfferMode(root);
      return;
    }
    if (!root || !url) return;
    const nextUrl = preservePreviewParams(new URL(url, window.location.origin));
    const currentSearch = root.querySelector('[data-lbx-live-search]')?.value || '';
    const viewMode = root.getAttribute('data-lbx-view-mode') || currentView();
    const openFilterKeys = getOpenFilterKeys(root);
    const wasFilterPanelOpen = root.classList.contains('is-filter-open');

    if (currentRequestController) currentRequestController.abort();
    currentRequestController = new AbortController();

    root.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: currentRequestController.signal
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextRoot = doc.querySelector(SELECTOR);
      if (!nextRoot) throw new Error('Catalog section not found');

      const pairs = [
        ['.lbxcat-quick-wrap', '.lbxcat-quick-wrap'],
        ['[data-lbx-filter-panel]', '[data-lbx-filter-panel]'],
        ['.lbxcat-main', '.lbxcat-main']
      ];

      pairs.forEach(([currentSelector, nextSelector]) => {
        const currentEl = root.querySelector(currentSelector);
        const nextEl = nextRoot.querySelector(nextSelector);
        if (currentEl && nextEl) currentEl.replaceWith(nextEl);
      });


      const nextSearch = root.querySelector('[data-lbx-live-search]');
      if (nextSearch && currentSearch) nextSearch.value = currentSearch;
      restoreFilterState(root, openFilterKeys);
      if (wasFilterPanelOpen) root.classList.add('is-filter-open');
      setView(root, viewMode, false);
      syncOfferMode(root);
      hydrateCards(root);
      updateStoreAvailabilityForSelectedColor(root);
      initHoverImages(root);
      prepareMobileFloatingToolbar(root);
      initCardColorSwatches(root);
      initDelegatedCardColorSwatches(root);
      root.querySelectorAll('[data-lbx-product-card]').forEach((card) => card.classList.remove('is-instant-hidden'));
      normalizeMaterialFilters(root);
      normalizeAvailabilityFilterOptions(root);
      syncClientMaterialFilter(root);
    moveFilterActionsToEnd(root);
    orderAndOpenFilters(root);
    moveFilterActionsToEnd(root);
    syncDependentFilterOptions(root);
    syncQuickChips(root);
      updateLiveState(root);
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      window.location.href = nextUrl.toString();
    } finally {
      root.classList.remove('is-loading');
      currentRequestController = null;
    }
  };

  const debounce = (fn, wait = 0) => {
    let timeout;
    return (...args) => {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => fn(...args), wait);
    };
  };


  const moveFilterActionsToEnd = (root) => {
    const form = root.querySelector('[data-lbx-filter-form]');
    const actions = form?.querySelector('.lbxcat-filter-form__actions');
    if (form && actions && actions.parentElement === form && actions !== form.lastElementChild) {
      form.appendChild(actions);
    }
  };

  const clearAllCatalogFilters = (root, options = {}) => {
    setClientMaterialModes(root, new Set());
    setOfferMode(root, false);

    const search = root.querySelector('[data-lbx-live-search]');
    if (search) search.value = '';

    root.querySelectorAll('[data-lbx-filter-form] input[type="checkbox"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute('data-lbx-search-auto');
      input.closest('.lbxcat-check, .lbxcat-color')?.classList.remove('is-active');
    });

    root.querySelectorAll('[data-lbx-price-input]').forEach((input) => { input.value = ''; });
    root.querySelectorAll('.is-client-disabled').forEach((label) => {
      label.classList.remove('is-client-disabled');
      label.hidden = false;
    });

    syncClientMaterialFilter(root);
    syncOfferMode(root);
    syncDependentFilterOptions(root);
    updateClientActiveChips(root);
    syncQuickChips(root);
    updateProductImagesForSelectedColor(root);
    syncCardColorSwatches(root);
    applyClientOnlyFilters(root);

    if (options.focusSearch && search) search.focus();
  };


  const hideRecentlyViewedBlocksSafe = () => {
    const selectors = [
      '[id*="recently-viewed" i]',
      '[id*="recently_viewed" i]',
      '[class*="recently-viewed" i]',
      '[class*="recently_viewed" i]',
      '[id*="recent-products" i]',
      '[class*="recent-products" i]'
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.display = 'none';
        element.setAttribute('hidden', '');
      });
    });
  };



  const normalizeAvailabilityFilterOptions = (root) => {
    if (!root) return;
    root.querySelectorAll('[data-lbx-filter]').forEach((filter) => {
      const label = normalizeText(filter.getAttribute('data-lbx-filter-label') || filter.querySelector('summary span')?.textContent || '');
      const key = normalizeText(filter.getAttribute('data-lbx-filter-key') || '');
      if (!label.includes('disponibilidad') && !label.includes('availability') && !key.includes('availability')) return;

      filter.querySelectorAll('.lbxcat-check').forEach((option) => {
        const input = option.querySelector('input');
        const label = option.querySelector('i');
        if (!input || !label) return;

        const rawValue = normalizeText(input.value || '');
        const unavailable = rawValue === '0' || rawValue === 'false';
        label.textContent = unavailable
          ? (root.getAttribute('data-lbx-stock-label-out') || 'Out of stock')
          : getCatalogLabel(root, 'in-stock', 'In stock');
      });
    });
  };


  const initCatalog = (root) => {
    if (!root || root.dataset.lbxCatalogReady === 'true') return;
    root.dataset.lbxCatalogReady = 'true';

    if (!root.dataset.lbxOfferMode && (getParams().has('lbx_offer') || getParams().has('lb_sale'))) root.dataset.lbxOfferMode = (getParams().get('lbx_offer') === '1' || getParams().get('lb_sale') === '1') ? '1' : '0';
    if (!root.dataset.lbxMaterialMode && getParams().has('lbx_material')) root.dataset.lbxMaterialMode = getParams().get('lbx_material') || '';
    setView(root, currentView(), false);
    if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) root.classList.add('is-mobile-force-list');
    hideRecentlyViewedBlocksSafe();
    syncOfferMode(root);
    hydrateCards(root);
    updateStoreAvailabilityForSelectedColor(root);
    initHoverImages(root);
    normalizeMaterialFilters(root);
    normalizeAvailabilityFilterOptions(root);
    syncClientMaterialFilter(root);
    const hasUrlCategoryFilter = applyUrlCategoryFilter(root);
    const hasAdvisorUrlFilters = applyAdvisorUrlFilters(root);
    syncDependentFilterOptions(root);
    syncQuickChips(root);
    if (CLIENT_ONLY_FILTERS && (hasUrlCategoryFilter || hasAdvisorUrlFilters || getOfferMode() || getClientMaterialModes().size)) {
      applyClientOnlyFilters(root);
      updateClientActiveChips(root);
      updateProductImagesForSelectedColor(root);
      syncCardColorSwatches(root);
    }
    // Build the Megamo-style visual chapters on initial load as well; later
    // filter/sort actions call the same routine again and refresh the headings.
    sortVisibleCards(root);

    const submitForm = (form, options = {}) => {
      if (!form) return;
      refreshCatalog(root, buildUrlFromForm(root, form), options);
    };

    const submitFormDebounced = debounce((form) => submitForm(form, { scroll: false }), 0);

    root.addEventListener('click', (event) => {
      const prioritySummary = event.target.closest('[data-lbx-filter-priority] > summary');
      if (prioritySummary && root.contains(prioritySummary)) {
        event.preventDefault();
        prioritySummary.closest('[data-lbx-filter]')?.setAttribute('open', '');
        return;
      }

      const clientMaterialButton = event.target.closest('[data-lbx-client-material-toggle]');
      if (clientMaterialButton && root.contains(clientMaterialButton)) {
        return;
      }

      const materialButton = event.target.closest('[data-lbx-material-toggle]');
      if (materialButton && root.contains(materialButton)) {
        event.preventDefault();
        const filter = materialButton.closest('.lbxcat-filter--material');
        const form = materialButton.closest('[data-lbx-filter-form]');
        const key = normalizeText(materialButton.getAttribute('data-lbx-material-toggle'));
        const nextChecked = materialButton.getAttribute('aria-pressed') !== 'true';
        filter?.querySelectorAll(`.lbxcat-check--material[data-lbx-material-key="${key}"] input`).forEach((input) => {
          input.checked = nextChecked;
          input.closest('.lbxcat-check--material')?.classList.toggle('is-active', nextChecked);
        });
        syncMaterialButtons(filter);
        if (CLIENT_ONLY_FILTERS) {
          applyClientOnlyFilters(root);
          updateClientActiveChips(root);
          syncQuickChips(root);
        } else {
          submitForm(form, { scroll: false });
        }
        return;
      }

      const viewButton = event.target.closest('[data-lbx-view]');
      if (viewButton && root.contains(viewButton)) {
        event.preventDefault();

        if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
          setView(root, 'list', false);
          root.classList.add('is-mobile-force-list');
        } else {
          setView(root, viewButton.dataset.lbxView);
        }

        updateProductImagesForSelectedColor(root);
        return;
      }

      const offerButton = event.target.closest('[data-lbx-offer-toggle]');
      if (offerButton && root.contains(offerButton)) {
        event.preventDefault();
        setOfferMode(root, !getOfferMode());
        syncOfferMode(root);
        if (CLIENT_ONLY_FILTERS) {
          applyClientOnlyFilters(root);
          updateClientActiveChips(root);
          syncQuickChips(root);
        } else {
          applyInstantFilterPreview(root);
        }
        return;
      }

      const openFilters = event.target.closest('[data-lbx-open-filters]');
      if (openFilters && root.contains(openFilters)) {
        event.preventDefault();
        ensureMobileFilterCloseButton(root);
        setMobileFilterViewportVars(root);
        ensureBodyMobileFilterCloseButton(root);
        root.classList.add('is-filter-open');
        document.body.classList.add('lbxcat-filter-open');
        document.documentElement.classList.add('lbxcat-filter-open');
        setMobileFilterViewportVars(root);
        return;
      }

      const closeFilters = event.target.closest('[data-lbx-close-filters]');
      if (closeFilters && root.contains(closeFilters)) {
        event.preventDefault();
        closeFilterPanel(root);
        return;
      }

      const clearSearch = event.target.closest('[data-lbx-clear-search]');
      if (clearSearch && root.contains(clearSearch)) {
        event.preventDefault();
        const isMobile = isMobileViewport();
        clearAllCatalogFilters(root, { focusSearch: !isMobile });
        syncMobileSearchInputs(root);
        root.classList.remove('is-mobile-searching');
        root.style.removeProperty('--lbxcat-mobile-search-min-height');
        unlockMobileCatalogHeightIfNoSearch(root);
        syncMobileBottomSearch();
        return;
      }

      const pricePreset = event.target.closest('[data-lbx-price-preset]');
      if (pricePreset && root.contains(pricePreset)) {
        event.preventDefault();
        const form = pricePreset.closest('[data-lbx-filter-form]');
        const min = pricePreset.getAttribute('data-lbx-price-min') || '';
        const max = pricePreset.getAttribute('data-lbx-price-max') || '';
        const inputs = form?.querySelectorAll('[data-lbx-price-input]') || [];
        if (inputs[0]) inputs[0].value = min ? `${min} €` : '';
        if (inputs[1]) inputs[1].value = max ? `${max} €` : '';
        root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
          const price = Number(card.getAttribute('data-lbx-price') || '0');
          const minN = Number(min || '0');
          const maxN = max ? Number(max) : Infinity;
          card.classList.toggle('is-instant-hidden', !(price >= minN && price <= maxN));
        });
        if (CLIENT_ONLY_FILTERS) {
          applyClientOnlyFilters(root);
          updateClientActiveChips(root);
          syncQuickChips(root);
        } else {
          submitForm(form, { scroll: false });
        }
        return;
      }

      const clearFiltersLink = event.target.closest('.lbxcat-filter-form__actions a');
      if (clearFiltersLink && root.contains(clearFiltersLink)) {
        event.preventDefault();
        clearAllCatalogFilters(root);
        return;
      }


      const quickChip = event.target.closest('.lbxcat-quick a, .lbxcat-quick button, .lbxcat-chip');
      if (quickChip && root.contains(quickChip) && quickChip.closest('.lbxcat-quick-wrap, .lbxcat-quick')) {
        event.preventDefault();
        const quickValue = quickValueFromElement(quickChip);
        setQuickCategory(root, quickValue);
        return;
      }

      const ajaxLink = event.target.closest('a');
      if (ajaxLink && root.contains(ajaxLink)) {
        const href = ajaxLink.getAttribute('href');
        const isCatalogLink = ajaxLink.closest('.lbxcat-quick, .lbxcat-active, .lbxcat-pagination, .lbxcat-filter-form__actions');
        const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || ajaxLink.target === '_blank';
        if (href && isCatalogLink && !modified) {
          event.preventDefault();
          refreshCatalog(root, href, { scroll: false });
        }
      }
    });

    root.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-lbx-filter-form], [data-lbx-sort-form]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      submitForm(form);
    });

    root.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
      const filterForm = input.closest('[data-lbx-filter-form]');
      const sortForm = input.closest('[data-lbx-sort-form]');
      if (input.matches('[data-lbx-client-material-toggle]')) {
        const active = getClientMaterialModes();
        const key = normalizeText(input.getAttribute('data-lbx-client-material-toggle'));
        if (input.checked) active.add(key); else active.delete(key);
        setClientMaterialModes(root, active);
        syncClientMaterialFilter(root);
        updateLiveState(root);
        if (CLIENT_ONLY_FILTERS) {
          applyClientOnlyFilters(root);
          updateClientActiveChips(root);
          syncQuickChips(root);
        } else {
          applyInstantFilterPreview(root);
        }
        return;
      }
      if (filterForm && (input.type === 'checkbox' || input.type === 'radio')) {
        const checkLabel = input.closest('.lbxcat-check, .lbxcat-color');
        if (checkLabel) checkLabel.classList.toggle('is-active', input.checked);
        syncSingleColorSelection(root, input);
        syncMaterialGroup(input);
        syncDependentFilterOptions(root);
        if (CLIENT_ONLY_FILTERS) {
          preserveViewportPosition(root, () => {
            applyClientOnlyFilters(root);
            updateClientActiveChips(root);
            syncQuickChips(root);
            updateProductImagesForSelectedColor(root);
          });
        } else {
          preserveViewportPosition(root, () => {
            applyInstantFilterPreview(root);
            submitForm(filterForm, { scroll: false });
          });
        }
      }
      if (sortForm && input.matches('[data-lbx-auto-submit]')) {
        if (CLIENT_ONLY_FILTERS) {
          sortVisibleCards(root);
        } else {
          submitForm(sortForm, { scroll: false });
        }
      }
    });

    root.addEventListener('input', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.matches('[data-lbx-live-search]')) {
        const isMobile = isMobileViewport();

        syncMobileSearchInputs(root, input);

        if (isMobile) {
          // Mobile: do not lock the catalogue height while typing.
          // When few products match, keeping the old height leaves the user in a blank area.
          root.classList.remove('is-mobile-searching');
          root.style.removeProperty('--lbxcat-mobile-search-min-height');
          clearSearchAutoFilters(root);
        } else {
          syncSearchAutoFilters(root);
        }

        if (CLIENT_ONLY_FILTERS) {
          applyClientOnlyFilters(root);
          updateClientActiveChips(root);
          syncQuickChips(root);
          updateProductImagesForSelectedColor(root);
          syncCardColorSwatches(root);
        }
        else updateLiveState(root);

        if (isMobile && input.value.trim()) {
          window.requestAnimationFrame(() => {
            ensureMobileSearchResultsVisible(root);
            syncMobileBottomSearch();
          });
        } else {
          unlockMobileCatalogHeightIfNoSearch(root);
          syncMobileBottomSearch();
        }
      }
      if (input.matches('[data-lbx-price-input]')) {
        if (CLIENT_ONLY_FILTERS) {
          applyClientOnlyFilters(root);
          updateClientActiveChips(root);
          syncQuickChips(root);
        } else {
          submitFormDebounced(input.closest('[data-lbx-filter-form]'));
        }
      }
    });

    root.addEventListener('focusin', (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.matches('[data-lbx-price-input]')) {
        input.value = cleanFormValue(input.value);
        input.select?.();
      }
    });

    root.addEventListener('focusout', (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.matches('[data-lbx-price-input]')) {
        const clean = cleanFormValue(input.value);
        const numeric = clean ? Math.round(Number(clean)) : '';
        input.value = numeric ? `${numeric} €` : '';
      }
    });

    root.addEventListener('click', (event) => {
      if (!root.classList.contains('is-filter-open')) return;
      const panel = root.querySelector('[data-lbx-filter-panel]');
      if (!panel || panel.contains(event.target) || event.target.closest('[data-lbx-open-filters]')) return;
      closeFilterPanel(root);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-filter-open')) closeFilterPanel(root);
    });

    window.addEventListener('popstate', () => refreshCatalog(root, window.location.href, { scroll: false }));
  };

  if (redirectLegacyShopifyCategoryToClientUrl()) return;

  const initAll = () => document.querySelectorAll(SELECTOR).forEach(initCatalog);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);

  const forceCatalogViewMode = (root, mode) => {
    if (!root) return;
    const next = mode === 'list' ? 'list' : 'grid';
    root.setAttribute('data-lbx-view-mode', next);
    root.classList.toggle('is-view-list', next === 'list');
    root.classList.toggle('is-view-grid', next === 'grid');
    root.querySelectorAll('[data-lbx-view]').forEach((button) => {
      const active = button.getAttribute('data-lbx-view') === next;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { window.localStorage.setItem(STORAGE_KEY, next); } catch (error) {}
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-lbx-view]');
    if (!button) return;
    const root = button.closest('[data-lbx-catalog]');
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    forceCatalogViewMode(root, button.getAttribute('data-lbx-view'));
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lbx-catalog]').forEach((root) => {
      let stored = 'grid';
      try { stored = window.localStorage.getItem(STORAGE_KEY) || root.getAttribute('data-lbx-view-mode') || 'grid'; } catch (error) {}
      forceCatalogViewMode(root, stored);
    });
  });



  const filterPriority = (label = '') => {
    const text = normalizeText(label);

    if (text.includes('disponibilidad') || text.includes('stock')) return 10;
    if (text.includes('precio')) return 20;
    if (text.includes('talla')) return 30;
    if (text.includes('categoria') || text.includes('categoría')) return 40;
    if (text.includes('modalidad') || text.includes('disciplina') || text.includes('uso principal')) return 50;
    if (text.includes('marca')) return 60;
    if (text.includes('motor')) return 70;
    if (text.includes('bateria') || text.includes('batería') || text.includes('battery')) return 80;
    if ((text.includes('suspension') || text.includes('suspensión')) && !text.includes('recorrido')) return 90;
    if (text.includes('recorrido')) return 100;
    if (text.includes('material') || text.includes('cuadro')) return 110;
    if (text.includes('color') || text.includes('colour')) return 120;

    return 999;
  };

  const shouldOpenFilterByDefault = (label = '') => {
    const text = normalizeText(label);
    return text.includes('disponibilidad') ||
      text.includes('precio') ||
      text.includes('talla') ||
      text.includes('categoria') ||
      text.includes('categoría') ||
      text.includes('material') ||
      text.includes('cuadro') ||
      text.includes('color') ||
      text.includes('colour');
  };

  const orderAndOpenFilters = (root = document) => {
    const scope = root.matches?.('[data-lbx-catalog]') ? root : (root.querySelector?.('[data-lbx-catalog]') || root);
    const filters = Array.from(scope.querySelectorAll?.('[data-lbx-filter]') || []);
    if (!filters.length) return;

    const parent = filters[0].parentElement;
    if (!parent || parent.dataset.lbxFilterOrderApplied === 'true') {
      // Still enforce open state in case Shopify/Theme rehydrated the filters.
      filters.forEach((filter) => {
        const summaryText = filter.getAttribute('data-lbx-filter-label') || filter.querySelector('summary span')?.textContent || '';
        const hasSelected = Boolean(filter.querySelector('input:checked'));
        if (shouldOpenFilterByDefault(summaryText) || hasSelected) filter.setAttribute('open', '');
      });
      return;
    }

    filters
      .map((filter, index) => {
        const summaryText = filter.getAttribute('data-lbx-filter-label') || filter.querySelector('summary span')?.textContent || '';
        return { filter, index, priority: filterPriority(summaryText), label: summaryText };
      })
      .sort((a, b) => (a.priority - b.priority) || (a.index - b.index))
      .forEach(({ filter, label }) => {
        const hasSelected = Boolean(filter.querySelector('input:checked'));
        if (shouldOpenFilterByDefault(label) || hasSelected) filter.setAttribute('open', '');
        else filter.removeAttribute('open');
        parent.appendChild(filter);
      });

    parent.dataset.lbxFilterOrderApplied = 'true';
  };



  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lbx-catalog]').forEach(orderAndOpenFilters);
  });



  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lbx-catalog]').forEach((catalog) => {
      initCardColorSwatches(catalog);
      initDelegatedCardColorSwatches(catalog);
      syncCardColorSwatches(catalog);
    });
  });

  window.addEventListener('load', () => {
    document.querySelectorAll('[data-lbx-catalog]').forEach((catalog) => {
      initCardColorSwatches(catalog);
      initDelegatedCardColorSwatches(catalog);
      syncCardColorSwatches(catalog);
    });
  });


  document.addEventListener('DOMContentLoaded', hideRecentlyViewedBlocksSafe);
  window.addEventListener('load', hideRecentlyViewedBlocksSafe);

  let lbxMobileBottomSearchTick = false;

  const isMobileViewport = () => window.matchMedia && window.matchMedia('(max-width: 760px)').matches;

  const lockMobileCatalogHeightForSearch = (root) => {
    if (!root || !isMobileViewport()) return;

    const input = root.querySelector('[data-lbx-live-search]');
    const hasQuery = Boolean(input && input.value.trim());

    if (!hasQuery) {
      root.classList.remove('is-mobile-searching');
      root.style.removeProperty('--lbxcat-mobile-search-min-height');
      return;
    }

    const currentHeight = Math.ceil(root.getBoundingClientRect().height);
    const previous = Number((root.style.getPropertyValue('--lbxcat-mobile-search-min-height') || '').replace('px', '')) || 0;
    const nextHeight = Math.max(previous, currentHeight, Math.ceil(window.innerHeight * 1.15));

    root.style.setProperty('--lbxcat-mobile-search-min-height', `${nextHeight}px`);
    root.classList.add('is-mobile-searching');
  };

  const unlockMobileCatalogHeightIfNoSearch = (root) => {
    if (!root) return;
    const input = root.querySelector('[data-lbx-live-search]');
    if (input && input.value.trim()) return;

    root.classList.remove('is-mobile-searching');
    root.style.removeProperty('--lbxcat-mobile-search-min-height');
  };

  const visibleCatalogCards = (root) => Array.from(root.querySelectorAll('[data-lbx-product-card]')).filter((card) => {
    if (card.hidden) return false;
    if (card.classList.contains('is-instant-hidden') || card.classList.contains('is-search-hidden')) return false;
    return window.getComputedStyle(card).display !== 'none';
  });

  const ensureMobileSearchResultsVisible = (root) => {
    if (!root || !isMobileViewport()) return;

    const input = root.querySelector('[data-lbx-live-search]');
    if (!input || !input.value.trim()) return;

    const toolbar = root.querySelector('.lbxcat-toolbar:not([data-lbx-mobile-floating-toolbar])');
    const toolbarHeight = toolbar ? Math.ceil(toolbar.getBoundingClientRect().height) : 72;
    const topOffset = toolbarHeight + 18;

    const cards = visibleCatalogCards(root);
    const target = cards[0] || root.querySelector('[data-lbx-live-empty], [data-lbx-product-list], .lbxcat-products');
    if (!target) return;

    const anyCardInViewport = cards.some((card) => {
      const rect = card.getBoundingClientRect();
      return rect.bottom > topOffset + 16 && rect.top < window.innerHeight - 24;
    });

    if (anyCardInViewport) return;

    const targetTop = target.getBoundingClientRect().top + window.scrollY - topOffset;
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const nextTop = Math.max(0, Math.min(targetTop, maxScroll));

    if (Math.abs(window.scrollY - nextTop) > 24) {
      window.scrollTo({ top: nextTop, behavior: 'smooth' });
    }
  };


  const syncMobileSearchInputs = (root, sourceInput = null) => {
    if (!root) return;
    const value = sourceInput ? sourceInput.value : (root.querySelector('[data-lbx-live-search]')?.value || '');

    root.querySelectorAll('[data-lbx-live-search]').forEach((input) => {
      if (input !== sourceInput && input.value !== value) input.value = value;
    });
  };

  const prepareMobileFloatingToolbar = (root) => {
    return;
  };

  const prepareAllMobileFloatingToolbars = () => {
    return;
  };


  const syncMobileBottomSearch = () => {
    const isMobile = isMobileViewport();
    document.querySelectorAll('[data-lbx-catalog]').forEach((root) => {
      root.classList.remove('is-mobile-toolbar-floating');

      if (isMobile) {
        root.classList.add('is-mobile-force-list');
      } else {
        unlockMobileCatalogHeightIfNoSearch(root);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    prepareAllMobileFloatingToolbars();
    syncMobileBottomSearch();
  });
  document.addEventListener('focusout', (event) => {
    const input = event.target.closest?.('[data-lbx-live-search]');
    if (!input) return;

    const root = input.closest('[data-lbx-catalog]');
    if (!root) return;

    window.requestAnimationFrame(() => {
      unlockMobileCatalogHeightIfNoSearch(root);
      syncMobileBottomSearch();
    });
  });


  window.addEventListener('load', syncMobileBottomSearch);
  window.addEventListener('scroll', syncMobileBottomSearch, { passive: true });
  window.addEventListener('resize', syncMobileBottomSearch, { passive: true });


  const removeMobileFloatingToolbarClones = () => {
    document.querySelectorAll('[data-lbx-mobile-floating-toolbar]').forEach((toolbar) => toolbar.remove());
  };

  document.addEventListener('DOMContentLoaded', removeMobileFloatingToolbarClones);
  window.addEventListener('load', removeMobileFloatingToolbarClones);

  window.addEventListener('resize', () => {
    const root = lbxActiveMobileFilterRoot || document.querySelector('[data-lbx-catalog].is-filter-open');
    if (!root) return;
    setMobileFilterViewportVars(root);
    ensureBodyMobileFilterCloseButton(root);
  }, { passive: true });

  window.addEventListener('orientationchange', () => {
    window.setTimeout(() => {
      const root = lbxActiveMobileFilterRoot || document.querySelector('[data-lbx-catalog].is-filter-open');
      if (!root) return;
      setMobileFilterViewportVars(root);
      ensureBodyMobileFilterCloseButton(root);
    }, 120);
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = lbxActiveMobileFilterRoot || document.querySelector('[data-lbx-catalog].is-filter-open');
    if (root) closeFilterPanel(root);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lbx-catalog]').forEach(ensureMobileFilterCloseButton);
  });

  let lbxDesktopToolbarTick = false;

  const syncDesktopToolbarCompact = () => {
    if (lbxDesktopToolbarTick) return;

    lbxDesktopToolbarTick = true;
    window.requestAnimationFrame(() => {
      lbxDesktopToolbarTick = false;

      const isDesktop = !(window.matchMedia && window.matchMedia('(max-width: 760px)').matches);

      document.querySelectorAll('[data-lbx-catalog]').forEach((root) => {
        if (!isDesktop) {
          root.classList.remove('is-desktop-toolbar-compact');
          return;
        }

        const rect = root.getBoundingClientRect();
        const toolbar = root.querySelector('.lbxcat-toolbar');
        if (!toolbar) return;

        const hasEnteredCatalogue = rect.top < -120;
        const catalogueStillVisible = rect.bottom > window.innerHeight * 0.45;

        root.classList.toggle('is-desktop-toolbar-compact', hasEnteredCatalogue && catalogueStillVisible);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', syncDesktopToolbarCompact);
  window.addEventListener('load', syncDesktopToolbarCompact);
  window.addEventListener('scroll', syncDesktopToolbarCompact, { passive: true });
  window.addEventListener('resize', syncDesktopToolbarCompact, { passive: true });


})();

/* LABOSCH CATALOG v1013 - limpiar Consultar fantasma y estabilizar filtros móvil */
(() => {
  const isMobile = () => window.matchMedia && window.matchMedia('(max-width: 760px)').matches;

  const cleanupGhostConsultBadges = (scope = document) => {
    scope.querySelectorAll?.('.lbxcat-badge--muted').forEach((badge) => {
      const text = (badge.textContent || '').trim().toLowerCase();
      if (!text || text.includes('consult')) {
        const wrap = badge.closest('.lbxcat-card__badges--bottom-left');
        if (wrap) wrap.remove();
        else badge.remove();
      }
    });
  };

  const getOpenRoot = () => document.querySelector('[data-lbx-catalog].is-filter-open');

  const hardenMobileFilterState = (root) => {
    if (!root || !isMobile()) return;
    const panel = root.querySelector('[data-lbx-filter-panel], .lbxcat-filters');
    if (!panel) return;

    root.classList.add('is-filter-open');
    root.classList.remove('is-mobile-toolbar-floating');
    document.documentElement.classList.add('lbxcat-filter-open');
    document.body.classList.add('lbxcat-filter-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    panel.style.pointerEvents = 'auto';
    panel.style.overflowY = 'auto';
    panel.style.webkitOverflowScrolling = 'touch';
    panel.style.touchAction = 'pan-y';
    panel.style.zIndex = '2147483000';
  };

  const releaseMobileFilterState = () => {
    if (document.querySelector('[data-lbx-catalog].is-filter-open')) return;
    document.documentElement.classList.remove('lbxcat-filter-open');
    document.body.classList.remove('lbxcat-filter-open');
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-lbx-open-filters]');
    if (open) {
      const root = open.closest('[data-lbx-catalog]');
      window.requestAnimationFrame(() => hardenMobileFilterState(root));
      setTimeout(() => hardenMobileFilterState(root), 80);
      return;
    }

    if (event.target.closest?.('[data-lbx-close-filters], [data-lbx-body-close-filters]')) {
      setTimeout(releaseMobileFilterState, 80);
    }
  }, true);

  document.addEventListener('touchmove', (event) => {
    const root = getOpenRoot();
    if (!root || !isMobile()) return;
    const panel = root.querySelector('[data-lbx-filter-panel], .lbxcat-filters');
    if (panel && panel.contains(event.target)) return;
    event.preventDefault();
  }, { passive: false, capture: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setTimeout(releaseMobileFilterState, 80);
  }, true);

  document.addEventListener('DOMContentLoaded', () => cleanupGhostConsultBadges(document));
  window.addEventListener('load', () => cleanupGhostConsultBadges(document));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node && node.nodeType === 1) cleanupGhostConsultBadges(node);
      });
    });
  });

  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* LABOSCH catalog v1015 — final mobile filter interaction guard + desktop scroll lock */
(() => {
  const isMobile = () => window.matchMedia && window.matchMedia('(max-width:760px)').matches;
  const rootSel = '[data-lbx-catalog]';
  const panelSel = '[data-lbx-filter-panel], .lbxcat-filters';

  const openPanel = (root) => {
    if (!root) return;
    const panel = root.querySelector(panelSel);
    root.classList.add('is-filter-open');
    document.documentElement.classList.add('lbxcat-filter-open');
    document.body.classList.add('lbxcat-filter-open');
    if (isMobile()) {
      const header = document.querySelector('header, .shopify-section-header, .section-header, .header-wrapper');
      const rect = header?.getBoundingClientRect?.();
      const top = Math.max(8, Math.ceil((rect && rect.bottom > 0 ? rect.bottom : 0) + 8));
      root.style.setProperty('--lbx-mobile-filter-top', `${top}px`);
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    if (panel) {
      panel.style.pointerEvents = 'auto';
      panel.style.overflowY = 'auto';
      panel.style.webkitOverflowScrolling = 'touch';
      panel.style.touchAction = 'pan-y';
    }
  };

  const closePanel = (root) => {
    if (!root) return;
    root.classList.remove('is-filter-open');
    root.style.removeProperty('--lbx-mobile-filter-top');
    if (!document.querySelector(`${rootSel}.is-filter-open`)) {
      document.documentElement.classList.remove('lbxcat-filter-open');
      document.body.classList.remove('lbxcat-filter-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-lbx-open-filters]');
    if (open) {
      const root = open.closest(rootSel) || document.querySelector(rootSel);
      if (!root) return;
      event.preventDefault();
      event.stopPropagation();
      openPanel(root);
      return;
    }
    if (event.target.closest?.('[data-lbx-close-filters], [data-lbx-body-close-filters]')) {
      const root = document.querySelector(`${rootSel}.is-filter-open`);
      if (root) {
        event.preventDefault();
        event.stopPropagation();
        closePanel(root);
      }
    }
  }, true);

  document.addEventListener('click', (event) => {
    const panel = event.target.closest?.(panelSel);
    if (panel && panel.closest(rootSel)?.classList.contains('is-filter-open')) {
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('touchmove', (event) => {
    const root = document.querySelector(`${rootSel}.is-filter-open`);
    if (!root || !isMobile()) return;
    const panel = root.querySelector(panelSel);
    if (panel && panel.contains(event.target)) return;
    event.preventDefault();
  }, { capture:true, passive:false });

  const restoreScrollAfterFilterChange = (event) => {
    const root = event.target.closest?.(rootSel);
    if (!root || !event.target.closest?.('[data-lbx-filter-form]')) return;
    if (isMobile()) return;
    const x = window.scrollX;
    const y = window.scrollY;
    requestAnimationFrame(() => window.scrollTo(x, y));
    setTimeout(() => window.scrollTo(x, y), 80);
    setTimeout(() => window.scrollTo(x, y), 220);
  };
  document.addEventListener('change', restoreScrollAfterFilterChange, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-lbx-filter-form] input[type="checkbox"], [data-lbx-filter-form] input[type="radio"], .lbxcat-check')) restoreScrollAfterFilterChange(event);
  }, true);
})();


/* LABOSCH catalog v1020 — filtros móvil/tablet sin bloqueo global */
(() => {
  const isTouchCatalog = () => {
    try { return window.matchMedia('(max-width: 1024px)').matches || (navigator.maxTouchPoints || 0) > 0; }
    catch(e){ return window.innerWidth <= 1024; }
  };

  const ensureClose = (root) => {
    if (!root || !isTouchCatalog()) return;
    const panel = root.querySelector('[data-lbx-filter-panel], .lbxcat-filters');
    if (!panel) return;
    let close = panel.querySelector('[data-lbx-close-filters]');
    if (!close) {
      close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('data-lbx-close-filters', '');
      close.setAttribute('aria-label', root.getAttribute('data-lbx-label-close-filters') || 'Close filters');
      close.className = 'lbxcat-filters__close lbxcat-mobile-filter-close';
      close.textContent = '×';
      panel.prepend(close);
    }
  };

  const closePanel = (root) => {
    if (!root) return;
    root.classList.remove('is-filter-open');
    document.documentElement.classList.remove('lbxcat-filter-open');
    document.body.classList.remove('lbxcat-filter-open');
    root.style.removeProperty('--lbx-mobile-filter-top');
    root.style.removeProperty('--lbx-mobile-filter-height');
    const bodyClose = document.querySelector('[data-lbx-body-close-filters]');
    if (bodyClose) bodyClose.hidden = true;
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest?.('[data-lbx-open-filters]');
    if (openButton) {
      const root = openButton.closest('[data-lbx-catalog]');
      if (root && isTouchCatalog()) ensureClose(root);
      return;
    }

    const closeButton = event.target.closest?.('[data-lbx-close-filters], [data-lbx-body-close-filters]');
    if (closeButton && isTouchCatalog()) {
      const root = closeButton.closest('[data-lbx-catalog]') || document.querySelector('[data-lbx-catalog].is-filter-open');
      if (root) {
        event.preventDefault();
        closePanel(root);
      }
    }
  }, false);

  const init = () => document.querySelectorAll('[data-lbx-catalog]').forEach(ensureClose);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* LABOSCH catalog v1021 — cierre cómodo de filtros + limpiar sin recarga */
(() => {
  const ROOT = '[data-lbx-catalog]';
  const PANEL = '[data-lbx-filter-panel], .lbxcat-filters';
  const TOUCH = () => {
    try { return window.matchMedia('(max-width: 1024px)').matches || (navigator.maxTouchPoints || 0) > 0; }
    catch (e) { return window.innerWidth <= 1024; }
  };

  const closePanel = (root) => {
    if (!root) return;
    root.classList.remove('is-filter-open');
    root.style.removeProperty('--lbx-mobile-filter-top');
    root.style.removeProperty('--lbx-mobile-filter-height');
    document.documentElement.classList.remove('lbxcat-filter-open');
    document.body.classList.remove('lbxcat-filter-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.querySelectorAll('[data-lbx-body-close-filters]').forEach((button) => {
      button.hidden = true;
      button.classList.remove('is-visible');
    });
  };

  const ensureCloseButton = (root) => {
    if (!root || !TOUCH()) return;
    const panel = root.querySelector(PANEL);
    if (!panel) return;

    let close = panel.querySelector('[data-lbx-close-filters]');
    if (!close) {
      close = document.createElement('button');
      close.type = 'button';
      close.className = 'lbxcat-filters__close lbxcat-mobile-filter-close';
      close.setAttribute('data-lbx-close-filters', '');
      close.setAttribute('aria-label', root.getAttribute('data-lbx-label-close-filters') || 'Close filters');
      close.textContent = '×';
      panel.prepend(close);
    }
  };

  const updateVisibleCount = (root) => {
    const counter = root.querySelector('[data-lbx-visible-count]');
    if (!counter) return;
    const visible = root.querySelectorAll('[data-lbx-product-card]:not([hidden])').length;
    counter.textContent = String(visible);
  };

  const clearFiltersWithoutReload = (root) => {
    if (!root) return;

    root.querySelectorAll('[data-lbx-filter-form] input[type="checkbox"], [data-lbx-filter-form] input[type="radio"]').forEach((input) => {
      input.checked = false;
      input.removeAttribute('data-lbx-search-auto');
      input.closest('.is-active')?.classList.remove('is-active');
      input.closest('.lbxcat-check, .lbxcat-color, .lbxcat-check--material')?.classList.remove('is-active');
    });

    root.querySelectorAll('[data-lbx-price-input]').forEach((input) => { input.value = ''; });
    root.querySelectorAll('[data-lbx-live-search]').forEach((input) => { input.value = ''; });
    root.querySelectorAll('[data-lbx-material-toggle][aria-pressed="true"]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
    root.querySelectorAll('.lbxcat-active__client-chip').forEach((chip) => chip.remove());
    root.querySelectorAll('.lbxcat-chip.is-active, .lbxcat-quick .is-active').forEach((chip) => chip.classList.remove('is-active'));
    root.classList.remove('is-offer-mode');

    root.querySelectorAll('[data-lbx-product-card]').forEach((card) => {
      card.hidden = false;
      card.style.display = '';
      card.classList.remove('is-instant-hidden');
    });

    updateVisibleCount(root);

    try {
      const url = new URL(window.location.href);
      const keep = new URLSearchParams();
      ['view', 'sort_by', 'lbx_cat'].forEach((key) => {
        const value = url.searchParams.get(key);
        if (value) keep.set(key, value);
      });
      const next = `${url.pathname}${keep.toString() ? `?${keep.toString()}` : ''}${url.hash || ''}`;
      window.history.replaceState({}, '', next);
    } catch (e) {}

    root.dispatchEvent(new CustomEvent('lbx:filters-cleared', { bubbles: true }));
  };

  const isClearFiltersControl = (target) => {
    const el = target.closest?.('[data-lbx-clear-filters], [data-lbx-clear-search], .lbxcat-filter-form__actions a, .lbxcat-active a, a[href*="filter."], a[href*="lbx_"]');
    if (!el) return null;
    const text = (el.textContent || el.getAttribute('aria-label') || '').trim().toLowerCase();
    const href = el.getAttribute('href') || '';
    if (text.includes('limpiar') || text.includes('borrar') || text.includes('clear') || text.includes('quitar filtros')) return el;
    if (el.matches('[data-lbx-clear-filters], [data-lbx-clear-search]')) return el;
    if (href && !href.includes('filter.') && !href.includes('lbx_') && text) return null;
    return null;
  };

  const bindSwipeClose = (root) => {
    if (!root || root.dataset.lbxSwipeCloseBound === 'true') return;
    root.dataset.lbxSwipeCloseBound = 'true';

    let startX = 0;
    let startY = 0;
    let tracking = false;

    root.addEventListener('touchstart', (event) => {
      if (!TOUCH() || !root.classList.contains('is-filter-open')) return;
      const panel = root.querySelector(PANEL);
      if (!panel || !panel.contains(event.target)) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
      tracking = true;
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (!tracking || !TOUCH() || !root.classList.contains('is-filter-open')) return;
      tracking = false;
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (Math.abs(dx) > 78 && Math.abs(dx) > Math.abs(dy) * 1.25) closePanel(root);
    }, { passive: true });
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-lbx-open-filters]');
    if (open && TOUCH()) {
      const root = open.closest(ROOT) || document.querySelector(ROOT);
      if (root) {
        ensureCloseButton(root);
        bindSwipeClose(root);
      }
      return;
    }

    const close = event.target.closest?.('[data-lbx-close-filters], [data-lbx-body-close-filters]');
    if (close && TOUCH()) {
      const root = close.closest(ROOT) || document.querySelector(`${ROOT}.is-filter-open`);
      if (root) {
        event.preventDefault();
        event.stopPropagation();
        closePanel(root);
      }
      return;
    }

    const clear = isClearFiltersControl(event.target);
    if (clear) {
      const root = clear.closest(ROOT) || document.querySelector(ROOT);
      if (!root) return;
      event.preventDefault();
      clearFiltersWithoutReload(root);
    }
  }, true);

  const init = () => document.querySelectorAll(ROOT).forEach((root) => {
    ensureCloseButton(root);
    bindSwipeClose(root);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* LABOSCH catalog v1022 — cierre visible universal para filtros móvil/tablet */
(() => {
  const TOUCH_QUERY = '(max-width: 1024px), (pointer: coarse)';
  const ROOT_SEL = '[data-lbx-catalog]';
  const CLOSE_SEL = '[data-lbx-universal-filter-close]';

  const isTouchLayout = () => {
    try {
      return window.matchMedia && window.matchMedia(TOUCH_QUERY).matches;
    } catch (e) {
      return window.innerWidth <= 1024;
    }
  };

  const getHeaderBottom = () => {
    const candidates = Array.from(document.querySelectorAll('header, .shopify-section-header, [data-section-type*="header"], .lbx-header, .labosch-header, .site-header'));
    let bottom = 0;
    candidates.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.height > 20 && rect.top <= 160) bottom = Math.max(bottom, rect.bottom);
    });
    return Math.max(12, Math.round(bottom || 0));
  };

  const getOpenRoot = () => document.querySelector(`${ROOT_SEL}.is-filter-open`);

  const closeFilters = () => {
    document.querySelectorAll(`${ROOT_SEL}.is-filter-open`).forEach((root) => {
      root.classList.remove('is-filter-open');
      root.style.removeProperty('--lbx-mobile-filter-top');
      root.style.removeProperty('--lbx-mobile-filter-height');
    });
    document.documentElement.classList.remove('lbxcat-filter-open');
    document.body.classList.remove('lbxcat-filter-open');
    updateClose();
  };

  const ensureClose = () => {
    let btn = document.querySelector(CLOSE_SEL);
    if (btn) return btn;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lbxcat-universal-filter-close';
    btn.setAttribute('data-lbx-universal-filter-close', '');
    btn.setAttribute('aria-label', getCatalogLabel(getOpenRoot(), 'close-filters', 'Close filters'));
    btn.innerHTML = '<span aria-hidden="true">×</span>';
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeFilters();
    }, { passive: false });
    document.body.appendChild(btn);
    return btn;
  };

  function updateClose() {
    const btn = ensureClose();
    const shouldShow = isTouchLayout() && !!getOpenRoot();
    if (!shouldShow) {
      btn.hidden = true;
      btn.classList.remove('is-visible');
      return;
    }
    const top = getHeaderBottom() + 12;
    btn.style.setProperty('--lbxcat-universal-close-top', `${top}px`);
    btn.hidden = false;
    btn.classList.add('is-visible');
  }

  const scheduleUpdate = () => window.requestAnimationFrame(updateClose);

  document.addEventListener('click', scheduleUpdate, true);
  document.addEventListener('touchend', scheduleUpdate, { passive: true, capture: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', () => setTimeout(updateClose, 250), { passive: true });

  const observer = new MutationObserver(scheduleUpdate);
  const start = () => {
    ensureClose();
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (document.body) observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll(ROOT_SEL).forEach((root) => observer.observe(root, { attributes: true, attributeFilter: ['class'] }));
    updateClose();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* LABOSCH catalog v1024 — hard unlock after closing mobile/tablet filters with X */
(() => {
  const ROOT_SEL = '[data-lbx-catalog]';
  const PANEL_SEL = '[data-lbx-filter-panel], .lbxcat-filters';
  const CLOSE_SEL = '[data-lbx-close-filters], [data-lbx-body-close-filters], [data-lbx-universal-filter-close], .lbxcat-filters__close, .lbxcat-mobile-filter-close, .lbxcat-body-filter-close, .lbxcat-universal-filter-close';
  const OPEN_SEL = '[data-lbx-open-filters]';
  const TOUCH_QUERY = '(max-width: 1024px), (pointer: coarse)';
  let unlockTimer = null;

  const isTouchLayout = () => {
    try { return window.matchMedia && window.matchMedia(TOUCH_QUERY).matches; }
    catch (e) { return window.innerWidth <= 1024; }
  };

  const hasAnyOpenOverlay = () => Boolean(document.querySelector([
    'x-drawer[open]',
    'x-modal[open]',
    'cart-drawer[open]',
    'header-sidebar[open]',
    'facets-drawer[open]'
  ].join(',')));

  const hasOpenCatalogFilters = () => Boolean(document.querySelector(`${ROOT_SEL}.is-filter-open`));

  const resetPanelInlineState = () => {
    document.querySelectorAll(`${ROOT_SEL}:not(.is-filter-open) ${PANEL_SEL}`).forEach((panel) => {
      panel.style.pointerEvents = '';
      panel.style.overflowY = '';
      panel.style.webkitOverflowScrolling = '';
      panel.style.touchAction = '';
      panel.style.zIndex = '';
    });
  };

  const hideFloatingCloseButtons = () => {
    document.querySelectorAll('[data-lbx-body-close-filters], [data-lbx-universal-filter-close], .lbxcat-body-filter-close, .lbxcat-universal-filter-close').forEach((button) => {
      button.hidden = true;
      button.classList.remove('is-visible');
      button.style.pointerEvents = 'none';
    });
  };

  const unlockDocumentScroll = () => {
    document.documentElement.classList.remove('lbxcat-filter-open');
    document.body.classList.remove('lbxcat-filter-open');
    document.documentElement.classList.add('lbxcat-scroll-unlocked');
    document.body.classList.add('lbxcat-scroll-unlocked');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    if (!hasAnyOpenOverlay()) {
      document.documentElement.classList.remove('lock');
    }

    window.clearTimeout(unlockTimer);
    unlockTimer = window.setTimeout(() => {
      if (!hasOpenCatalogFilters()) {
        document.documentElement.classList.remove('lbxcat-scroll-unlocked');
        document.body.classList.remove('lbxcat-scroll-unlocked');
      }
    }, 2500);
  };

  const hardCloseFilters = () => {
    document.querySelectorAll(`${ROOT_SEL}.is-filter-open`).forEach((root) => {
      root.classList.remove('is-filter-open');
      root.style.removeProperty('--lbx-mobile-filter-top');
      root.style.removeProperty('--lbx-mobile-filter-height');
      root.style.removeProperty('--lbxcat-universal-close-top');
    });
    hideFloatingCloseButtons();
    resetPanelInlineState();
    unlockDocumentScroll();
  };

  const scheduleHardClose = () => {
    hardCloseFilters();
    window.requestAnimationFrame(hardCloseFilters);
    window.setTimeout(hardCloseFilters, 60);
    window.setTimeout(hardCloseFilters, 180);
    window.setTimeout(hardCloseFilters, 420);
  };

  const prepareOpen = () => {
    window.clearTimeout(unlockTimer);
    document.documentElement.classList.remove('lbxcat-scroll-unlocked');
    document.body.classList.remove('lbxcat-scroll-unlocked');
    document.querySelectorAll('[data-lbx-body-close-filters], [data-lbx-universal-filter-close]').forEach((button) => {
      button.style.pointerEvents = '';
    });
  };

  document.addEventListener('pointerdown', (event) => {
    if (!isTouchLayout()) return;
    if (event.target.closest?.(OPEN_SEL)) prepareOpen();
    if (event.target.closest?.(CLOSE_SEL)) scheduleHardClose();
  }, true);

  document.addEventListener('touchend', (event) => {
    if (!isTouchLayout()) return;
    if (event.target.closest?.(CLOSE_SEL)) scheduleHardClose();
  }, { capture: true, passive: true });

  document.addEventListener('click', (event) => {
    if (!isTouchLayout()) return;
    if (event.target.closest?.(OPEN_SEL)) {
      prepareOpen();
      return;
    }
    if (event.target.closest?.(CLOSE_SEL)) scheduleHardClose();
  }, true);

  document.addEventListener('transitionend', () => {
    if (!hasOpenCatalogFilters()) {
      resetPanelInlineState();
      if (document.documentElement.classList.contains('lbxcat-filter-open') || document.body.classList.contains('lbxcat-filter-open')) {
        unlockDocumentScroll();
      }
    }
  }, true);

  const observer = new MutationObserver(() => {
    if (!isTouchLayout()) return;
    if (!hasOpenCatalogFilters() && (document.documentElement.classList.contains('lbxcat-filter-open') || document.body.classList.contains('lbxcat-filter-open'))) {
      scheduleHardClose();
    }
  });

  const start = () => {
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    if (document.body) observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    document.querySelectorAll(ROOT_SEL).forEach((root) => observer.observe(root, { attributes: true, attributeFilter: ['class', 'style'] }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* LABOSCH FILTER ENGINE FINAL OVERRIDE — generic desktop/tablet/mobile */
(() => {
  const ROOT = '[data-lbx-catalog]';
  const CARD = '[data-lbx-product-card]';
  const FORM = '[data-lbx-filter-form]';
  const norm = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
  const token = (value) => norm(value).replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  const tokens = (value) => token(value).split(' ').filter(Boolean);
  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));
  const nums = (value) => (String(value || '').match(/\d+/g) || []);

  const getUrlBrandValues = () => {
    const params = new URLSearchParams(window.location.search);
    const rawValues = [
      ...params.getAll('lbx_brand'),
      ...params.getAll('lbx_marca')
    ];

    return uniq(rawValues
      .flatMap((value) => String(value || '').split(','))
      .map((value) => token(value))
      .filter(Boolean));
  };

  const getCardBrandValue = (card) => token([
    card?.getAttribute?.('data-lbx-brand') || '',
    card?.querySelector?.('[data-lbx-card-brand]')?.textContent || '',
    card?.getAttribute?.('data-lbx-search') || ''
  ].join(' '));

  const cardMatchesUrlBrand = (card, urlBrands) => {
    if (!urlBrands.length) return true;
    const brand = getCardBrandValue(card);
    if (!brand) return false;

    return urlBrands.some((wanted) => {
      if (!wanted) return true;
      if (brand === wanted) return true;
      const brandTokens = tokens(brand);
      const wantedTokens = tokens(wanted);
      return wantedTokens.every((part) => brandTokens.includes(part) || brand.includes(part));
    });
  };

  const syncUrlBrandCheckboxes = (root, urlBrands) => {
    if (!root || !urlBrands.length) return;

    root.querySelectorAll(`${FORM} input[type="checkbox"], ${FORM} input[type="radio"]`).forEach((input) => {
      if (filterType(input) !== 'brand') return;
      const inputValue = token(`${labelText(input)} ${input.value || ''}`);
      const shouldCheck = urlBrands.some((wanted) => {
        if (!wanted) return false;
        if (inputValue === wanted) return true;
        const inputTokens = tokens(inputValue);
        const wantedTokens = tokens(wanted);
        return wantedTokens.every((part) => inputTokens.includes(part) || inputValue.includes(part));
      });

      if (shouldCheck && !input.checked) {
        input.checked = true;
        input.setAttribute('checked', 'checked');
      }
    });
  };

  const labelText = (input) => input?.closest?.('label')?.querySelector?.('i')?.textContent
    || input?.closest?.('label')?.textContent
    || input?.value
    || '';

  const getFilter = (input) => input?.closest?.('[data-lbx-filter]');
  const getFilterLabel = (filter) => filter?.getAttribute('data-lbx-filter-label')
    || filter?.querySelector?.('summary span')?.textContent
    || filter?.querySelector?.('summary')?.textContent
    || '';

  const filterType = (input) => {
    const filter = getFilter(input);
    const text = token(`${getFilterLabel(filter)} ${filter?.getAttribute('data-lbx-filter-key') || ''} ${input?.name || ''} ${input?.value || ''}`);
    if (text.includes('talla') || text.includes('size') || text.includes('option talla') || text.includes('option size')) return 'size';
    if (text.includes('marca') || text.includes('brand') || text.includes('vendor')) return 'brand';
    if (text.includes('categoria') || text.includes('categor') || text.includes('badge categoria')) return 'category';
    if (text.includes('modalidad') || text.includes('disciplina') || text.includes('uso principal')) return 'discipline';
    if (text.includes('color') || text.includes('colour')) return 'color';
    if (text.includes('bateria') || text.includes('battery')) return 'battery';
    if (text.includes('motor')) return 'motor';
    if (text.includes('disponibilidad') || text.includes('availability')) return 'availability';
    if (text.includes('suspension') || text.includes('suspensión')) return 'suspension';
    if (text.includes('recorrido')) return 'travel';
    if (text.includes('cuadro') || text.includes('material')) return 'frame';
    if (text.includes('filter v option') || text.includes('option')) return 'option';
    return 'generic';
  };

  const groupKey = (input) => {
    const filter = getFilter(input);
    const label = token(getFilterLabel(filter));
    const key = token(filter?.getAttribute('data-lbx-filter-key') || input?.name || label || filterType(input));
    return `${filterType(input)}::${label || key}`;
  };

  const getInputValue = (input) => token(`${labelText(input)} ${input?.value || ''}`);
  const canonicalSize = (value) => {
    const t = token(value);
    if (/(^| )xxs( |$)/.test(t)) return 'xxs';
    if (/(^| )xs( |$)/.test(t)) return 'xs';
    if (/(^| )xxl( |$)/.test(t)) return 'xxl';
    if (/(^| )xl( |$)/.test(t)) return 'xl';
    if (/(^| )l( |$)/.test(t)) return 'l';
    if (/(^| )m( |$)/.test(t)) return 'm';
    if (/(^| )s( |$)/.test(t)) return 's';
    if (/(^| )unica( |$)/.test(t) || /(^| )unico( |$)/.test(t)) return 'unica';
    return t;
  };

  const COLOR_FAMILIES = {
    black: ['black', 'negro', 'negra'],
    white: ['white', 'blanco', 'blanca'],
    grey: ['grey', 'gray', 'gris', 'plata', 'silver', 'titanium', 'titanio'],
    blue: ['blue', 'azul', 'navy', 'marine', 'marino'],
    green: ['green', 'verde', 'argile', 'olive', 'oliva'],
    red: ['red', 'rojo', 'roja'],
    orange: ['orange', 'naranja'],
    yellow: ['yellow', 'amarillo', 'amarilla'],
    brown: ['brown', 'marron', 'cafe', 'cobre', 'copper'],
    beige: ['beige', 'cream', 'crema', 'sand', 'arena'],
    purple: ['purple', 'purpura', 'morado', 'morada', 'violeta', 'lila', 'lavender'],
    pink: ['pink', 'rosa'],
    gold: ['gold', 'dorado', 'dorada']
  };

  const localColorAliases = (value) => {
    const selected = token(value);
    const aliases = new Set(selected ? [selected] : []);
    Object.values(COLOR_FAMILIES).forEach((family) => {
      const normalizedFamily = family.map(token);
      if (normalizedFamily.some((entry) => selected === entry || selected.includes(entry) || entry.includes(selected))) {
        normalizedFamily.forEach((entry) => aliases.add(entry));
      }
    });
    return Array.from(aliases).filter(Boolean);
  };

  const getCardColorValue = (card) => [
    card.getAttribute('data-lbx-color') || '',
    card.getAttribute('data-lbx-options') || '',
    ...Array.from(card.querySelectorAll('[data-lbx-variant-stock]')).map((node) => node.getAttribute('data-lbx-variant-color') || ''),
    ...Array.from(card.querySelectorAll('[data-lbx-card-color-swatch]')).map((node) => [
      node.getAttribute('data-lbx-swatch-key') || '',
      node.getAttribute('data-lbx-swatch-label') || '',
      node.getAttribute('aria-label') || ''
    ].join(' '))
  ].join(' ');

  const VARIANT_SCOPED_TYPES = new Set(['size', 'option', 'color', 'battery', 'motor', 'availability']);

  const getVariantRecords = (card) => Array.from(card.querySelectorAll('[data-lbx-variant-stock]')).map((node) => ({
    options: node.getAttribute('data-lbx-variant-options') || '',
    color: node.getAttribute('data-lbx-variant-color') || '',
    battery: node.getAttribute('data-lbx-variant-battery') || '',
    motor: node.getAttribute('data-lbx-variant-motor') || '',
    availability: node.getAttribute('data-lbx-variant-availability') || '',
    ownStock: Number(node.getAttribute('data-lbx-variant-own-stock') || '0'),
    supplierStock: Number(node.getAttribute('data-lbx-variant-supplier-stock') || '0')
  }));

  const variantField = (variant, type) => {
    if (type === 'size' || type === 'option') return variant.options;
    if (type === 'color') return `${variant.color} ${variant.options}`;
    if (type === 'battery') return `${variant.battery} ${variant.options}`;
    if (type === 'motor') return variant.motor;
    if (type === 'availability') return variant.availability;
    return variant.options;
  };

  const cardField = (card, type) => {
    if (type === 'size') return [card.getAttribute('data-lbx-options'), card.getAttribute('data-lbx-search'), card.getAttribute('data-lbx-title')].join(' ');
    if (type === 'option') return [card.getAttribute('data-lbx-options'), card.getAttribute('data-lbx-battery'), card.getAttribute('data-lbx-color'), card.getAttribute('data-lbx-search'), card.getAttribute('data-lbx-title')].join(' ');
    if (type === 'brand') return [card.getAttribute('data-lbx-brand'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'category') return [card.getAttribute('data-lbx-category'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'discipline') return [card.getAttribute('data-lbx-discipline'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'battery') return [card.getAttribute('data-lbx-battery'), card.getAttribute('data-lbx-options'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'color') return getCardColorValue(card);
    if (type === 'availability') return card.getAttribute('data-lbx-availability') || '';
    if (type === 'motor') return [card.getAttribute('data-lbx-motor'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'travel') return [card.getAttribute('data-lbx-travel'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'suspension') return [card.getAttribute('data-lbx-suspension'), card.getAttribute('data-lbx-search')].join(' ');
    if (type === 'frame') return [card.getAttribute('data-lbx-frame'), card.getAttribute('data-lbx-material'), card.getAttribute('data-lbx-search')].join(' ');
    return [card.getAttribute(`data-lbx-${type}`), card.getAttribute('data-lbx-search'), card.getAttribute('data-lbx-options')].join(' ');
  };

  const textHasValue = (haystackRaw, needleRaw) => {
    const hay = token(haystackRaw);
    const needle = token(needleRaw);
    if (!needle) return true;
    if (!hay) return false;
    if (hay === needle) return true;
    const hayTokens = tokens(hay);
    const needleTokens = tokens(needle);
    return needleTokens.every((n) => hayTokens.includes(n) || hay.includes(n));
  };

  const fieldMatchesValue = (field, type, valueRaw) => {
    const value = token(valueRaw);
    const fieldTokens = tokens(field);

    if (type === 'size') {
      const selected = canonicalSize(value);
      if (!selected) return true;
      const availableSizes = new Set(fieldTokens.map(canonicalSize));
      // Exact size tokens only: M must never match XL or a word containing “m”.
      return availableSizes.has(selected);
    }

    if (type === 'battery' || type === 'travel') {
      const wantedNums = nums(value);
      const fieldNums = nums(field);
      if (wantedNums.length && fieldNums.length) return wantedNums.some((n) => fieldNums.includes(n));
    }

    if (type === 'availability') {
      const wanted = token(value);
      const status = token(field);
      if (wanted.includes('sin stock') || wanted.includes('agotado') || wanted.includes('sold out')) return status === 'sold out';
      if (wanted.includes('envio') || wanted.includes('24 48') || wanted.includes('24h') || wanted.includes('48h')) return status === 'in stock';
      if (wanted.includes('en stock') || wanted.includes('disponible') || wanted.includes('available')) return status === 'in stock' || status === 'supplier stock';
      return textHasValue(status, wanted);
    }

    if (type === 'color') {
      const fieldText = token(field);
      const availableTokens = new Set(tokens(fieldText));
      return localColorAliases(valueRaw).some((alias) => {
        const normalizedAlias = token(alias);
        return normalizedAlias && (
          fieldText === normalizedAlias ||
          availableTokens.has(normalizedAlias) ||
          fieldText.includes(normalizedAlias)
        );
      });
    }

    return textHasValue(field, value);
  };

  const cardMatchesValue = (card, type, valueRaw) => fieldMatchesValue(cardField(card, type), type, valueRaw);
  const variantMatchesValue = (variant, type, valueRaw) => fieldMatchesValue(variantField(variant, type), type, valueRaw);

  const getGroups = (root) => {
    const groups = new Map();
    root.querySelectorAll(`${FORM} input[type="checkbox"]:checked, ${FORM} input[type="radio"]:checked`).forEach((input) => {
      const filter = getFilter(input);
      if (!filter) return;
      const type = filterType(input);
      const key = groupKey(input);
      const value = getInputValue(input);
      if (!value) return;

      if (!groups.has(key)) {
        const allInputs = Array.from(filter.querySelectorAll('input[type="checkbox"], input[type="radio"]'))
          .filter((candidate) => !candidate.disabled && !candidate.closest('label')?.hidden);
        groups.set(key, { type, values: new Set(), selected: new Set(), all: new Set() });
        allInputs.forEach((candidate) => groups.get(key).all.add(getInputValue(candidate)));
      }
      const group = groups.get(key);
      group.values.add(value);
      group.selected.add(value);
    });

    // Merge duplicate desktop/mobile groups by type + label and de-duplicate values.
    return Array.from(groups.values()).filter((group) => {
      const values = uniq(Array.from(group.values));
      const all = uniq(Array.from(group.all));
      group.values = values;
      group.all = all;

      // All options selected means no restriction for that group.
      if (all.length > 1 && values.length >= all.length && all.every((v) => values.includes(v))) return false;

      // Size shortcuts: all/common size universe selected means “any size”.
      if (group.type === 'size') {
        const sizes = new Set(values.map(canonicalSize));
        const common = ['xs', 's', 'm', 'l', 'xl', 'xxl', 'unica'];
        const hitCount = common.filter((s) => sizes.has(s)).length;
        if (hitCount >= 5 && (sizes.has('m') || sizes.has('l')) && (sizes.has('s') || sizes.has('xs'))) return false;
      }
      return values.length > 0;
    });
  };

  const cleanPrice = (value) => String(value || '').replace(/€/g, '').replace(/\s+/g, '').replace(/\./g, '').replace(/,/g, '.');

  const applyFinalFilters = (root) => {
    if (!root) return;
    root.__lbxApplyingFinalFilters = true;
    const urlBrands = getUrlBrandValues();
    syncUrlBrandCheckboxes(root, urlBrands);
    const groups = getGroups(root);
    const searchInput = root.querySelector('[data-lbx-live-search]');
    const queryTerms = tokens(searchInput?.value || '');
    const minInput = root.querySelector(`${FORM} [name*="filter.v.price.gte"], ${FORM} [name*="price.gte"], ${FORM} [name*="min"]`);
    const maxInput = root.querySelector(`${FORM} [name*="filter.v.price.lte"], ${FORM} [name*="price.lte"], ${FORM} [name*="max"]`);
    const minPrice = Number(cleanPrice(minInput?.value) || '0');
    const maxPrice = cleanPrice(maxInput?.value) ? Number(cleanPrice(maxInput.value)) : Infinity;
    const material = root.dataset.lbxMaterialMode ? new Set(String(root.dataset.lbxMaterialMode).split(',').map(norm).filter(Boolean)) : new Set();
    const offerOnly = root.dataset.lbxOfferMode === '1' || new URLSearchParams(location.search).get('lbx_offer') === '1' || new URLSearchParams(location.search).get('lb_sale') === '1';

    let visible = 0;
    root.querySelectorAll(CARD).forEach((card) => {
      let show = true;
      const searchable = token(card.getAttribute('data-lbx-search') || `${card.getAttribute('data-lbx-title') || ''} ${card.textContent || ''}`);
      const price = Number(card.getAttribute('data-lbx-price') || '0');

      if (queryTerms.length && !queryTerms.every((q) => searchable.includes(q))) show = false;
      if (show && urlBrands.length && !cardMatchesUrlBrand(card, urlBrands)) show = false;
      if (show && offerOnly && card.getAttribute('data-lbx-sale') !== 'true') show = false;
      if (show && material.size && !material.has(norm(card.getAttribute('data-lbx-material') || ''))) show = false;
      if (show && (price < minPrice || price > maxPrice)) show = false;

      if (show) {
        const productGroups = groups.filter((group) => !VARIANT_SCOPED_TYPES.has(group.type));
        const variantGroups = groups.filter((group) => VARIANT_SCOPED_TYPES.has(group.type));

        for (const group of productGroups) {
          // OR inside one product-level group: AMFLOW OR FOCUS, montaña OR urbana, etc.
          if (!group.values.some((value) => cardMatchesValue(card, group.type, value))) {
            show = false;
            break;
          }
        }

        if (show && variantGroups.length) {
          const variants = getVariantRecords(card);

          if (variants.length) {
            const hasSizeGroup = variantGroups.some((group) => group.type === 'size');
            const hasAvailabilityGroup = variantGroups.some((group) => group.type === 'availability');

            // AND between groups must be satisfied by the same variant.
            // A size on its own only matches when that exact size has PHYSICAL
            // LaBosch stock. Supplier / reservation stock does not pass the size filter.
            show = variants.some((variant) => {
              const matchesSelectedVariantFilters = variantGroups.every((group) =>
                group.values.some((value) => variantMatchesValue(variant, group.type, value))
              );

              if (!matchesSelectedVariantFilters) return false;

              if (hasSizeGroup && !hasAvailabilityGroup) {
                return Number(variant.ownStock || 0) > 0;
              }

              return true;
            });
          } else {
            // Backwards compatibility for cards rendered before the variant map existed.
            show = variantGroups.every((group) =>
              group.values.some((value) => cardMatchesValue(card, group.type, value))
            );

            const hasSizeGroup = variantGroups.some((group) => group.type === 'size');
            const hasAvailabilityGroup = variantGroups.some((group) => group.type === 'availability');
            if (show && hasSizeGroup && !hasAvailabilityGroup) {
              // Without variant-level stock we cannot prove that this size is
              // physically available, so do not expose a false-positive result.
              show = false;
            }
          }
        }
      }

      card.hidden = !show;
      card.style.display = show ? '' : 'none';
      card.classList.toggle('is-instant-hidden', !show);
      card.classList.remove('is-search-hidden');
      if (show) visible += 1;
    });

    const count = root.querySelector('[data-lbx-visible-count]');
    if (count) count.textContent = String(visible);
    window.requestAnimationFrame(() => { root.__lbxApplyingFinalFilters = false; });
  };

  const scheduleApply = (root) => {
    if (!root) return;
    clearTimeout(root.__lbxFinalFilterTimer);
    root.__lbxFinalFilterTimer = setTimeout(() => applyFinalFilters(root), 30);
    setTimeout(() => applyFinalFilters(root), 180);
  };

  const initRoot = (root) => {
    if (!root || root.dataset.lbxFinalFilterEngine === 'true') return;
    root.dataset.lbxFinalFilterEngine = 'true';
    ['change', 'input', 'keyup', 'click'].forEach((eventName) => {
      root.addEventListener(eventName, () => scheduleApply(root), true);
    });

    // El catálogo tiene varios scripts que pueden volver a pintar/mostrar tarjetas después
    // de la primera carga. Este observer reaplica el filtro de URL si otro motor lo pisa.
    if ('MutationObserver' in window) {
      const observer = new MutationObserver(() => {
        if (root.__lbxApplyingFinalFilters) return;
        scheduleApply(root);
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden', 'style', 'class']
      });
      root.__lbxFinalFilterObserver = observer;
    }

    scheduleApply(root);
    window.setTimeout(() => applyFinalFilters(root), 350);
    window.setTimeout(() => applyFinalFilters(root), 900);
  };

  const init = () => document.querySelectorAll(ROOT).forEach(initRoot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
